<!-- Main container following application layout patterns -->
<div class="main-content"> <!-- Header section consistent with other pages -->
  <div *ngIf="canCreate() || canUpdate()">
    <div class="header-section">
      <div class="d-flex justify-content-between align-items-center">
        <div class="wm-heading">
          <div class="wm-heading-icon wm-heading-icon--teal">
            <i class="fas fa-dolly"></i>
          </div>
          <div>
            <h1 class="main-title">{{ 'SHIPMENT_REQUEST.TITLE' | translate }}</h1>
            <p class="main-subtitle">{{ 'SHIPMENT_REQUEST.SUBTITLE' | translate }}</p>
          </div>
        </div>

        <div class="header-actions">

          <!-- Scambio canale di inserimento (da flusso <-> form):
               solo per chi dispone dell'inserimento da file -->
          <button type="button" class="data-entry-switch"
                  *ngIf="canSwitchDataEntryView"
                  (click)="toggleDataEntryView()"
                  [title]="dataEntryView === 'file'
                    ? 'Passa al form di inserimento manuale'
                    : 'Torna alla sezione inserimento da flusso (file Excel)'">
            <i class="fas" [ngClass]="dataEntryView === 'file' ? 'fa-keyboard' : 'fa-file-excel'"></i>
            <span>{{ dataEntryView === 'file' ? 'Inserimento manuale' : 'Inserimento da flusso' }}</span>
          </button>

          <!-- Strumentario -->
          <div class="toolbox-container">
            <div class="toolbox-heading">
              <div class="toolbox-heading-icon">
                <i class="fas fa-tools"></i>
              </div>
              <div class="toolbox-heading-text">
                <span class="toolbox-title">Strumentario</span>
                <small class="toolbox-subtitle">Strumenti rapidi</small>
              </div>
            </div>
            <div class="toolbox-divider"></div>
            <div class="toolbox-buttons">

              <!-- Tour guidato -->
              <button type="button" class="toolbox-btn toolbox-btn--blue"
                      (click)="startTour()"
                      data-bs-toggle="tooltip"
                      data-bs-placement="bottom"
                      [title]="'TOUR.START_TOUR' | translate">
                <i class="fas fa-route"></i>
              </button>

              <!-- Mostra/Nascondi form: solo se il form manuale è visibile -->
              <button type="button" class="toolbox-btn toolbox-btn--green"
                      *ngIf="showInsertFormSections"
                      [class.active]="!isFormCollapsed"
                      (click)="toggleFormCollapse()"
                      [attr.aria-expanded]="!isFormCollapsed"
                      aria-controls="shipmentForm"
                      data-bs-toggle="tooltip"
                      data-bs-placement="bottom"
                      [title]="isFormCollapsed ? ('SHIPMENT_REQUEST.SHOW_FORM' | translate) : ('SHIPMENT_REQUEST.HIDE_FORM' | translate)">
                <i class="fas" [ngClass]="isFormCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
              </button>

              <!-- Densità tabella -->
              <button type="button" class="toolbox-btn toolbox-btn--orange"
                      [class.active]="isCompactTable"
                      (click)="toggleCompactTable()"
                      data-bs-toggle="tooltip"
                      data-bs-placement="bottom"
                      title="Attiva/Disattiva la vista compatta della tabella">
                <i class="fas fa-grip-lines"></i>
              </button>

            </div>
          </div>

        </div>
      </div>

      <!-- Loading indicator -->
      <div class="text-center mt-3" *ngIf="isLoading">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">{{ 'COMMON.LOADING' | translate }}</span>
        </div>
      </div>
    </div>

    <!-- ===== Sezione: Inserimento dati via file Excel =====
         Visibile all'ADMIN e agli utenti con la funzione 'shipment-request-by-file',
         e solo mentre è selezionato il canale "da flusso" (vedi pulsante Strumentario) -->
    <div id="excel-csv-section" class="card mb-4" *ngIf="showExcelImportPanel">
      <div class="card-header">
        <div class="d-flex justify-content-between align-items-center">
          <div class="header-title">
            <i class="fas fa-file-csv header-icon"></i>
            <h3>Inserimento Dati via File Excel</h3>
          </div>

          <button type="button" class="btn btn-sm btn-outline-secondary"
                  *ngIf="excelFiles.length || excelSendResult"
                  (click)="clearExcelConversion()"
                  title="Rimuovi tutti i file e svuota la sezione">
            <i class="fas fa-eraser me-1"></i>
            Pulisci tutto
          </button>
        </div>
      </div>

      <div class="card-body">
        <!-- Area drag & drop -->
        <div class="excel-dropzone"
             [class.is-dragover]="isExcelDragOver"
             [class.is-loading]="isConvertingExcel"
             (dragover)="onExcelDragOver($event)"
             (dragleave)="onExcelDragLeave($event)"
             (drop)="onExcelDrop($event)"
             (click)="openExcelFilePicker()"
             role="button"
             tabindex="0"
             (keydown.enter)="openExcelFilePicker()"
             (keydown.space)="openExcelFilePicker()">

          <input #excelFileInput
                 type="file"
                 class="excel-file-input"
                 multiple
                 [accept]="excelAcceptAttribute"
                 (change)="onExcelFileSelected($event)" />

          <div class="excel-dropzone-icon">
            <i class="fas" [ngClass]="isConvertingExcel ? 'fa-spinner fa-spin' : 'fa-file-excel'"></i>
          </div>

          <div class="excel-dropzone-text">
            <span class="excel-dropzone-title">
              {{ isConvertingExcel ? 'Conversione in corso...' :
                 (excelFiles.length ? 'Trascina altri file per aggiungerli' : 'Trascina qui i file Excel') }}
            </span>
            <small class="excel-dropzone-hint">
              anche più file insieme · accorpati in un unico CSV con le sole righe 5C / 5B ·
              max {{ excelMaxFileSizeMb }} MB ciascuno
            </small>
          </div>

          <button type="button" class="btn btn-primary btn-sm excel-choose-btn"
                  [disabled]="isConvertingExcel"
                  (click)="openExcelFilePicker(); $event.stopPropagation()">
            <i class="fas fa-folder-open me-1"></i>
            {{ excelFiles.length ? 'Aggiungi file' : 'Scegli file' }}
          </button>

          <div class="excel-formats">
            <span class="excel-format-chip" *ngFor="let ext of excelAcceptedExtensions">{{ ext }}</span>
          </div>
        </div>

        <!-- Errore -->
        <div class="alert alert-danger d-flex align-items-center mt-3 mb-0" *ngIf="excelErrorMessage">
          <i class="fas fa-exclamation-circle me-2"></i>
          <span>{{ excelErrorMessage }}</span>
        </div>

        <!-- Esito dell'ultimo invio: dopo l'invio riuscito resta l'unico contenuto -->
        <div class="excel-send-result mt-3" *ngIf="excelSendResult">
          <i class="fas fa-check-circle"></i>
          <div class="excel-send-result-text">
            <span class="excel-send-result-title">
              Invio completato ({{ excelSendResult.status }})
            </span>
            <small>
              {{ excelSendResult.receivedCharacters | number }} caratteri accettati
              <ng-container *ngIf="excelSendResult.receivedAt">
                · {{ excelSendResult.receivedAt | date:'dd/MM/yyyy HH:mm:ss' }}
              </ng-container>
              <ng-container *ngIf="excelSendResult.userCode">
                · utente {{ excelSendResult.userCode }}
              </ng-container>
            </small>
          </div>
          <button type="button" class="excel-send-result-close"
                  (click)="excelSendResult = null"
                  title="Nascondi l'avviso">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <!-- Nessun file ha righe collo: senza CSV il riquadro di controllo non
             compare, quindi il motivo dello scarto va detto qui -->
        <div class="alert alert-danger mt-3 mb-0" *ngIf="hasNoParcelRows">
          <div class="d-flex align-items-center">
            <i class="fas fa-exclamation-circle me-2"></i>
            <span>
              <strong>Nessuna riga valida:</strong>
              vengono prelevate solo le righe che hanno <strong>5C</strong> o <strong>5B</strong>
              nella seconda colonna, e nessuna riga dei file caricati rispetta questa condizione.
              Non c'è nulla da inviare: controlla il file o, se ha più fogli, seleziona quello giusto.
            </span>
          </div>
          <ul class="mb-0 mt-2 ps-4" *ngIf="excelFiles.length > 1">
            <li *ngFor="let file of excelFilesWithoutParcelRows">
              {{ file.name }}
              <ng-container *ngIf="file.sheetNames.length > 1">
                (foglio "{{ file.selectedSheet }}")
              </ng-container>
              <ng-container *ngIf="file.skippedRows">
                · {{ file.skippedRows | number }}
                {{ file.skippedRows === 1 ? 'riga scartata' : 'righe scartate' }}
              </ng-container>
            </li>
          </ul>
        </div>

        <!-- Card dei file caricati: l'ordine è quello di accorpamento, max 5 per riga -->
        <div class="excel-file-grid mt-3" *ngIf="excelFiles.length">
          <div class="excel-file-card"
               [class.is-empty]="!file.csv"
               [class.is-warning]="file.csv && getFileIssueCount(file)"
               *ngFor="let file of excelFiles; let i = index; trackBy: trackByExcelFileId">

            <span class="excel-file-order" title="Posizione nel CSV unificato">{{ i + 1 }}</span>

            <div class="excel-file-card-icon">
              <i class="fas"
                 [ngClass]="!file.csv ? 'fa-exclamation-triangle'
                            : (getFileIssueCount(file) ? 'fa-exclamation-circle' : 'fa-file-excel')"></i>
            </div>

            <div class="excel-file-card-text">
              <span class="excel-file-name" [title]="file.name">{{ file.name }}</span>

              <!-- Righe collo con dati mancanti: il file blocca l'invio -->
              <small class="excel-file-detail excel-file-detail--warning"
                     *ngIf="file.csv && getFileIssueCount(file) as issueCount"
                     title="Righe con dati obbligatori mancanti: finché ci sono, l'invio resta bloccato">
                {{ issueCount }} {{ issueCount === 1 ? 'riga con dati mancanti' : 'righe con dati mancanti' }}
              </small>

              <small class="excel-file-detail" *ngIf="file.csv && !getFileIssueCount(file)">
                {{ formatExcelFileSize(file.size) }} · {{ getExcelFileRowCount(file) }}
                {{ getExcelFileRowCount(file) === 1 ? 'riga collo' : 'righe collo' }}
                <ng-container *ngIf="file.skippedRows">
                  · {{ file.skippedRows }} scartate
                </ng-container>
              </small>

              <!-- Nessuna riga prelevata: il file non contribuisce al CSV -->
              <small class="excel-file-detail excel-file-detail--error" *ngIf="!file.csv"
                     title="Il parser prende solo le righe con 5C o 5B nella seconda colonna">
                nessuna riga 5C / 5B
                <ng-container *ngIf="file.skippedRows">
                  · {{ file.skippedRows }} {{ file.skippedRows === 1 ? 'riga scartata' : 'righe scartate' }}
                </ng-container>
              </small>
            </div>

            <!-- Selettore foglio: solo se il file ne ha più di uno -->
            <div class="excel-sheet-select" *ngIf="file.sheetNames.length > 1">
              <i class="fas fa-table"></i>
              <select class="form-select form-select-sm"
                      [ngModel]="file.selectedSheet"
                      [ngModelOptions]="{ standalone: true }"
                      (ngModelChange)="onExcelSheetChange(file, $event)"
                      title="Foglio da convertire">
                <option *ngFor="let sheet of file.sheetNames" [value]="sheet">{{ sheet }}</option>
              </select>
            </div>

            <button type="button" class="excel-file-remove"
                    (click)="removeExcelFile(file.id)"
                    title="Rimuovi questo file dall'unione">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>

        <!-- Risultato accorpato: resoconto a sinistra, invio a destra sulla stessa riga -->
        <ng-container *ngIf="excelCsvOutput">
          <div class="excel-result-row mt-3">
          <div class="excel-result-bar">
            <div class="excel-result-summary">
              <i class="fas fa-layer-group excel-result-icon"></i>
              <div class="excel-file-meta">
                <span class="excel-file-name">
                  {{ excelFiles.length }}
                  {{ excelFiles.length === 1 ? 'File inserito' : 'File inseriti' }}
                </span>
                <small class="excel-file-detail">
                  {{ formatExcelFileSize(excelTotalSize) }} · {{ excelCsvRowCount }}
                  {{ excelCsvRowCount === 1 ? 'riga collo' : 'righe collo' }} totali
                </small>
              </div>
            </div>

            <!-- Azioni sul CSV accorpato: non servono all'operatore, tenute qui
                 commentate per poterle riattivare all'occorrenza.
                 Il toggle "Marcatore tra i file" ha senso solo con più file.

            <div class="excel-result-actions">
              <button type="button" class="btn btn-sm excel-headers-toggle"
                      *ngIf="excelFiles.length > 1"
                      [class.active]="excelInsertFileMarkers"
                      (click)="toggleExcelFileMarkers()"
                      title="Inserisci una riga marcatore all'inizio di ogni file">
                <i class="fas" [ngClass]="excelInsertFileMarkers ? 'fa-check-square' : 'fa-square'"></i>
                Marcatore tra i file
              </button>

              <button type="button" class="btn btn-sm btn-outline-secondary"
                      (click)="copyCsvToClipboard()"
                      title="Copia la stringa CSV negli appunti">
                <i class="fas fa-copy me-1"></i>
                Copia
              </button>
              <button type="button" class="btn btn-sm btn-outline-secondary"
                      (click)="downloadCsv()"
                      title="Scarica il CSV come file">
                <i class="fas fa-download me-1"></i>
                Scarica
              </button>
            </div>
            -->
          </div>

          <!-- Esito del controllo: una card per parametro, fra il riepilogo e l'invio -->
          <ng-container *ngIf="csvCheck as check">
            <div class="excel-metric-card" title="Colli prelevati dal file (righe con 5C / 5B nella seconda colonna)">
              <i class="fas fa-boxes excel-result-icon"></i>
              <div>
                <div class="excel-metric-value">{{ check.parcelCount | number }}</div>
                <div class="excel-metric-label">Colli</div>
              </div>
            </div>

            <div class="excel-metric-card" title="Peso complessivo dei colli">
              <i class="fas fa-weight-hanging excel-result-icon"></i>
              <div>
                <div class="excel-metric-value">{{ check.totalWeight | number:'1.0-2' }} kg</div>
                <div class="excel-metric-label">Peso</div>
              </div>
            </div>

            <div class="excel-metric-card" title="Volume complessivo dei colli">
              <i class="fas fa-cube excel-result-icon"></i>
              <div>
                <div class="excel-metric-value">{{ check.totalVolume | number:'1.0-3' }} m³</div>
                <div class="excel-metric-label">Volume</div>
              </div>
            </div>
          </ng-container>

          <!-- Invio della stringa all'endpoint di inserimento dati -->
          <button type="button" class="excel-send-btn"
                  [disabled]="isSendingCsv || isExcelCsvTooLong || hasCsvIssues || !canCreate()"
                  (click)="sendCsvToBackend()"
                  [title]="!canCreate() ? 'Permesso di creazione mancante'
                           : (isExcelCsvTooLong ? 'La stringa supera il limite accettato'
                           : (hasCsvIssues ? 'Ci sono righe con dati mancanti: correggi il file prima di inviare'
                           : 'Invia la stringa CSV per l\'inserimento dati'))">
            <i class="fas" [ngClass]="isSendingCsv ? 'fa-spinner fa-spin' : 'fa-paper-plane'"></i>
            <span>{{ isSendingCsv ? 'Invio...' : 'Invia dati' }}</span>
          </button>
          </div>

          <!-- Avviso sul limite accettato dall'endpoint di inserimento -->
          <div class="alert alert-danger d-flex align-items-center mt-3 mb-0" *ngIf="isExcelCsvTooLong">
            <i class="fas fa-exclamation-triangle me-2"></i>
            <span>
              La stringa supera il limite di {{ excelCsvMaxLength | number }} caratteri accettato
              dall'inserimento dati: rimuovi qualche file o riduci i fogli selezionati.
            </span>
          </div>
          <div class="alert alert-warning d-flex align-items-center mt-3 mb-0" *ngIf="isExcelCsvNearLimit">
            <i class="fas fa-exclamation-circle me-2"></i>
            <span>
              Sei al {{ excelCsvLengthPercent | number:'1.0-0' }}% del limite di
              {{ excelCsvMaxLength | number }} caratteri.
            </span>
          </div>

          <!-- ===== Controllo del CSV: righe con dati mancanti ===== -->
          <div class="csv-check" *ngIf="csvCheck as check">

            <!-- Righe con almeno un dato obbligatorio mancante -->
            <div class="csv-check-issues" *ngIf="check.issues.length">
              <div class="csv-check-issues-head">
                <i class="fas fa-exclamation-triangle"></i>
                <span>
                  {{ check.issues.length }}
                  {{ check.issues.length === 1 ? 'riga con dati mancanti' : 'righe con dati mancanti' }}
                  · invio bloccato finché non vengono corrette
                </span>
              </div>
              <div class="csv-check-issue" *ngFor="let issue of check.issues">
                <span class="csv-check-issue-row"
                      [title]="'Riga ' + issue.sheetRow + ' del file ' + issue.fileName">
                  Riga {{ issue.sheetRow }}
                  <ng-container *ngIf="excelFiles.length > 1"> · {{ issue.fileName }}</ng-container>
                </span>
                <span class="csv-check-issue-messages">{{ issue.messages.join(' · ') }}</span>
              </div>
            </div>

            <div class="csv-check-ok" *ngIf="check.parcelCount && !check.issues.length">
              <i class="fas fa-check-circle"></i>
              <span>Tutte le righe collo hanno i dati obbligatori valorizzati</span>
            </div>

            <!-- Righe non prelevate: prive del marcatore 5C / 5B nella seconda colonna -->
            <div class="csv-check-skipped" *ngIf="check.parcelCount && check.skippedRows">
              <i class="fas fa-filter"></i>
              <span>
                {{ check.skippedRows | number }}
                {{ check.skippedRows === 1 ? 'riga scartata' : 'righe scartate' }}
                perché senza 5C o 5B nella seconda colonna (intestazioni, chiusure o righe senza
                marcatore): non fanno parte del CSV e non vengono inviate
              </span>
            </div>

            <!-- Alcuni file non hanno prodotto righe pur essendoci un CSV dagli altri -->
            <div class="csv-check-empty" *ngIf="excelFilesWithoutParcelRows.length">
              <i class="fas fa-exclamation-triangle"></i>
              <span>
                {{ excelFilesWithoutParcelRows.length }}
                {{ excelFilesWithoutParcelRows.length === 1 ? 'file non ha' : 'file non hanno' }}
                nessuna riga con 5C o 5B nella seconda colonna e non
                {{ excelFilesWithoutParcelRows.length === 1 ? 'contribuisce' : 'contribuiscono' }}
                al CSV:
                <strong>{{ excelFileNamesWithoutParcelRows }}</strong>
              </span>
            </div>

            <div class="csv-check-empty" *ngIf="!check.parcelCount">
              <i class="fas fa-exclamation-triangle"></i>
              <span>Nessuna riga con 5C o 5B nella seconda colonna: controlla il file caricato</span>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Form per inserimento spedizione (collassabile).
         Con l'inserimento da file disponibile compare solo scegliendo il canale "form",
         altrimenti resta l'unico canale ed è sempre presente. -->
    <div class="collapse" [ngClass]="{'show': !isFormCollapsed}" id="shipmentForm"
         *ngIf="showInsertFormSections">
      <form [formGroup]="shipmentForm" (ngSubmit)="onSubmit()" class="shipment-form">

        <!-- Sezione 1: Dati della Bolla -->
        <div class="card form-section">
          <div class="card-header">
            <div class="header-title">
              <i class="fas fa-file-alt header-icon"></i>
              <h3>{{ 'SHIPMENT_REQUEST.WAYBILL_DATA' | translate }}</h3>
            </div>
          </div>
          <div class="card-body"> <!-- Prima riga: Client, Brand e Data Richiesta -->
            <div class="row" formGroupName="waybill">
              <div class="col-md-4 mb-3">
                <label for="waybillClientCode" class="form-label">{{ 'SHIPMENT_REQUEST.CLIENT' | translate }} *</label>
                <div class="position-relative"> <select id="waybillClientCode" class="form-select ps-5"
                    formControlName="waybillClientCode" [class.is-invalid]="isFieldInvalid('waybill.waybillClientCode')">
                    <option value="" *ngIf="filteredClients.length > 1">
                      {{ 'SHIPMENT_REQUEST.SELECT_CLIENT' | translate }}
                    </option>
                    <option *ngFor="let client of filteredClients" [value]="client.clientCode">
                      {{ client.clientName || client.clientCode }}
                      <!--<span *ngIf="client.clientCode">({{ client.clientCode }})</span>-->
                    </option>
                  </select>
                  <i class="fas fa-user position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                </div>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('waybill.waybillClientCode')">
                  {{ getFieldError('waybill.waybillClientCode') }}
                </div>
              </div>
              <div class="col-md-4 mb-3">
                <label for="waybillBrandCode" class="form-label">{{ 'SHIPMENT_REQUEST.BRAND' | translate }} *</label>
                <div class="position-relative"> <select id="waybillBrandCode" class="form-select ps-5"
                    formControlName="waybillBrandCode" [class.is-invalid]="isFieldInvalid('waybill.waybillBrandCode')"
                    (change)="onBrandChange($event)">
                    <option value="" *ngIf="filteredBrands.length > 1">
                      {{ 'SHIPMENT_REQUEST.SELECT_BRAND' | translate }}
                    </option>
                    <option *ngFor="let brand of filteredBrands" [value]="brand.brandCode">
                      {{ brand.brandName || brand.brandCode }}
                      <!--<span *ngIf="brand.brandCode">({{ brand.brandName }})</span>-->
                    </option>
                  </select>
                  <i class="fas fa-tags position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                </div>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('waybill.waybillBrandCode')">
                  {{ getFieldError('waybill.waybillBrandCode') }}
                </div>
              </div>
              <div class="col-md-4 mb-3">
                <label for="waybillDate" class="form-label">{{ 'SHIPMENT_REQUEST.REQUESTED_DATE' | translate }}
                  *
                  <span class="max-insert-time-hint" *ngIf="hasMaxInsertTime"
                    [title]="'SHIPMENT_REQUEST.TIME_RESTRICTION_NOTICE' | translate: { time: maxInsertTimeLabel }">
                    <i class="fas fa-clock me-1"></i>{{ 'SHIPMENT_REQUEST.MAX_INSERT_TIME_HINT' | translate: { time: maxInsertTimeLabel } }}
                  </span>
                </label>
                <div class="position-relative"> <input type="text" id="waybillDate" class="form-control ps-5"
                    formControlName="waybillDate" #requestedDateInput
                    [class.is-invalid]="isFieldInvalid('waybill.waybillDate')"
                    [class.is-warning]="isDateFieldRestricted || isWeekendRestricted"
                    placeholder="{{ 'SHIPMENT_REQUEST.REQUESTED_DATE_PLACEHOLDER' | translate }}" readonly>
                  <i
                    class="fas fa-calendar-alt position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                  <!-- Time restriction warning icon -->
                  <i *ngIf="isDateFieldRestricted"
                    class="fas fa-exclamation-triangle position-absolute top-50 end-0 translate-middle-y me-3 text-warning"
                    [title]="timeRestrictionMessage"></i>
                  <!-- Weekend restriction warning icon -->
                  <i *ngIf="isWeekendRestricted && !isDateFieldRestricted"
                    class="fas fa-exclamation-triangle position-absolute top-50 end-0 translate-middle-y me-3 text-warning"
                    [title]="weekendRestrictionMessage"></i>
                </div>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('waybill.waybillDate')">
                  {{ getFieldError('waybill.waybillDate') }}
                </div>
                <!-- Time restriction message -->
                <div *ngIf="isDateFieldRestricted" class="small text-warning mt-1">
                  <i class="fas fa-clock me-1"></i>
                  {{ 'SHIPMENT_REQUEST.TIME_RESTRICTION_NOTICE' | translate: { time: maxInsertTimeLabel } }}
                </div>
                <!-- Weekend restriction message -->
                <div *ngIf="isWeekendRestricted && !isDateFieldRestricted" class="small text-warning mt-1">
                  <i class="fas fa-calendar-times me-1"></i>
                  {{ 'SHIPMENT_REQUEST.WEEKEND_RESTRICTION_NOTICE' | translate }}
                </div>
              </div>
            </div> <!-- Seconda riga: Codice Bolla, Codice Spedizione e Magazzino -->
            <div class="row" formGroupName="waybill">
              <div class="col-md-4 mb-3">
                <label for="waybillCode" class="form-label">{{ 'SHIPMENT_REQUEST.WAYBILL_CODE' | translate }}<span *ngIf="isFieldRequired('waybillCode')" class="text-danger ms-1">*</span></label>
                <div class="position-relative">
                  <input type="text" id="waybillCode" class="form-control ps-5" formControlName="waybillCode"
                    (input)="onWaybillCodeInput($event)"
                    [class.is-invalid]="isFieldInvalid('waybill.waybillCode')"
                    [placeholder]="getFieldPlaceholder('waybillCode', 'SHIPMENT_REQUEST.WAYBILL_CODE_AUTO_PLACEHOLDER' | translate)">
                  <i class="fas fa-barcode position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                </div>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('waybill.waybillCode')">
                  {{ getFieldError('waybill.waybillCode') }}
                </div>
              </div>
              <div class="col-md-4 mb-3">
                <label for="waybillShipmentCode" class="form-label">{{ 'SHIPMENT_REQUEST.SHIPMENT_CODE' | translate
                  }}</label>
                <div class="position-relative">
                  <input type="text" id="waybillShipmentCode" class="form-control ps-5"
                    formControlName="waybillShipmentCode"
                    [class.is-invalid]="isFieldInvalid('waybill.waybillShipmentCode')"
                    placeholder="{{ 'SHIPMENT_REQUEST.SHIPMENT_CODE_AUTO_PLACEHOLDER' | translate }}">
                  <i
                    class="fas fa-shipping-fast position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                </div>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('waybill.waybillShipmentCode')">
                  {{ getFieldError('waybill.waybillShipmentCode') }}
                </div>
              </div>
              <div class="col-md-4 mb-3">
                <label for="waybillOriginLocation" class="form-label">{{ 'SHIPMENT_REQUEST.WAREHOUSE' | translate }} *</label>
                <div class="position-relative">
                  <select id="waybillOriginLocation" class="form-select ps-5"
                    formControlName="waybillOriginLocation"
                    [class.is-invalid]="isFieldInvalid('waybill.waybillOriginLocation')">
                    <option value="">{{ 'SHIPMENT_REQUEST.SELECT_WAREHOUSE' | translate }}</option>
                    <option *ngFor="let warehouse of filteredWarehouses" [value]="warehouse.warehouseCode">
                      {{ warehouse.warehouseName || warehouse.warehouseCode }}
                    </option>
                  </select>
                  <i class="fas fa-warehouse position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                </div>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('waybill.waybillOriginLocation')">
                  {{ getFieldError('waybill.waybillOriginLocation') }}
                </div>
              </div>
            </div> <!-- Terza riga: Note -->
            <div class="row" formGroupName="waybill">
              <div class="col-md-12 mb-3">
                <label for="waybillNote" class="form-label">
                  {{ 'SHIPMENT_REQUEST.NOTES' | translate }}
                </label>
                <div class="position-relative">
                  <textarea id="waybillNote" class="form-control ps-5" formControlName="waybillNote" rows="3"
                    maxlength="200" [class.is-invalid]="isFieldInvalid('waybill.waybillNote')"
                    placeholder="{{ 'SHIPMENT_REQUEST.NOTES_PLACEHOLDER' | translate }}"></textarea>
                  <i class="fas fa-sticky-note position-absolute top-0 start-0 ms-3 mt-3 text-muted"></i>
                </div>
                <div class="d-flex justify-content-between">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('waybill.waybillNote')">
                    {{ getFieldError('waybill.waybillNote') }}
                  </div>
                  <small class="text-muted"
                    [class.text-danger]="shipmentForm.get('waybill.waybillNote')?.value?.length > 200">
                    {{ shipmentForm.get('waybill.waybillNote')?.value?.length || 0 }}/200
                  </small>
                </div>
              </div>
            </div>

            <!-- Time restriction message for Waybill Data section -->
            <div *ngIf="isTimeRestricted" class="alert alert-warning d-flex align-items-center mt-3 mb-0">
              <i class="fas fa-exclamation-triangle me-2"></i>
              <div>
                <strong>{{ 'SHIPMENT_REQUEST.TIME_RESTRICTION_TITLE' | translate }}</strong><br>
                <small>{{ timeRestrictionMessage }}</small>
              </div>
            </div>
          </div>
        </div> <!-- Sezione 2: Dati dei Colli -->
        <div class="card form-section">
          <div class="card-header">
            <div class="d-flex justify-content-between align-items-center">
              <div class="header-title">
                <i class="fas fa-cube header-icon"></i>
                <h3>{{ 'SHIPMENT_REQUEST.PARCELS_DATA' | translate }}</h3>
              </div>
              <div class="d-flex gap-2">
                <!-- Pulsante Inserimento Distributivo -->
                <button 
                  type="button" 
                  class="btn btn-primary" 
                  (click)="openDistributiveInsertPopup()"
                  [title]="'SHIPMENT_REQUEST.DISTRIBUTIVE_INSERT' | translate">
                  <i class="fas fa-th me-1"></i>
                  {{ 'SHIPMENT_REQUEST.DISTRIBUTIVE_INSERT' | translate }}
                </button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div formArrayName="parcels">
              <div *ngFor="let parcel of parcelsArray.controls; trackBy: trackParcelControlById; let i = index" [formGroupName]="i"
                class="card parcel-card mb-3">

                <div class="card-header d-flex justify-content-between align-items-center">
                  <div class="flex-grow-1 d-flex align-items-center flex-wrap">
                    <h5 class="mb-0 me-3">
                      <i class="fas fa-cube me-2"></i>
                      {{ 'SHIPMENT_REQUEST.PARCEL' | translate }} {{ i + 1 }}
                    </h5>
                    <!-- Mostra informazioni aggiuntive quando il collo è collassato -->
                    <div *ngIf="isParcelCollapsed(i)" class="parcel-summary-inline d-flex flex-wrap align-items-center">
                      <!-- Descrizione -->
                      <span class="me-2 text-primary">
                        <i class="fas fa-file-alt me-1"></i>
                        {{ parcelsArray.at(i).get('parcelDescription')?.value || '-' }}
                      </span>
                      <!-- Peso -->
                      <span class="me-2">
                        <i class="fas fa-weight-hanging me-1"></i>
                        {{ parcelsArray.at(i).get('parcelWeight')?.value ? (parcelsArray.at(i).get('parcelWeight')?.value | number:'1.1-3') + ' kg' : '-' }}
                      </span>
                      <!-- Volume -->
                      <span class="me-2">
                        <i class="fas fa-expand-arrows-alt me-1"></i>
                        {{ parcelsArray.at(i).get('parcelVolume')?.value ? (parcelsArray.at(i).get('parcelVolume')?.value | number:'1.1-4') + ' m³' : '-' }}
                      </span>
                      <!-- Valore assicurato -->
                      <span class="me-2">
                        <i class="fas fa-euro-sign me-1"></i>
                        {{ parcelsArray.at(i).get('parcelInsuredValue')?.value ? (parcelsArray.at(i).get('parcelInsuredValue')?.value | number:'1.2-2') + ' €' : '-' }}
                      </span>
                      <!-- Dimensioni -->
                      <span class="me-2">
                        <i class="fas fa-ruler me-1"></i>
                        {{ parcelsArray.at(i).get('parcelLength')?.value ? (parcelsArray.at(i).get('parcelLength')?.value | number:'1.1-1') : '-' }}×{{ parcelsArray.at(i).get('parcelWidth')?.value ? (parcelsArray.at(i).get('parcelWidth')?.value | number:'1.1-1') : '-' }}×{{ parcelsArray.at(i).get('parcelHeight')?.value ? (parcelsArray.at(i).get('parcelHeight')?.value | number:'1.1-1') : '-' }} cm
                      </span>
                    </div>
                  </div>
                  <div class="d-flex gap-2">
                    <!-- Pulsante per aprire questo collo e chiudere gli altri -->
                    <button type="button" class="btn btn-outline-info btn-sm me-3" (click)="openParcelCloseOthers(i)"
                      [title]="'SHIPMENT_REQUEST.OPEN_CLOSE_OTHERS' | translate">
                      <i class="fas fa-eye"></i>
                    </button>
                    <!-- Pulsante per collassare/espandere il collo -->
                    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="toggleParcelCollapse(i)"
                      [title]="isParcelCollapsed(i) ? ('SHIPMENT_REQUEST.EXPAND_PARCEL' | translate) : ('SHIPMENT_REQUEST.COLLAPSE_PARCEL' | translate)">
                      <i class="fas" [ngClass]="isParcelCollapsed(i) ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
                    </button>
                    <!-- Pulsante per rimuovere il collo -->
                    <button type="button" class="btn btn-outline-danger btn-sm" (click)="removeParcel(i)"
                      [disabled]="parcelsArray.length === 1">
                      <i class="fas fa-trash"></i>
                    </button>
                  </div>
                </div>
                <div class="card-body collapse" [ngClass]="{'show': !isParcelCollapsed(i)}">
                  <div class="row"> <!-- First Row: Only Parcel Code -->
                    <div class="col-md-12 mb-3">
                      <label for="parcelCode{{ i }}" class="form-label">{{ 'SHIPMENT_REQUEST.PARCEL_CODE' | translate
                        }}<span *ngIf="isFieldRequired('parcelCode')" class="text-danger ms-1">*</span></label>
                      <div class="position-relative">
                        <input type="text" id="parcelCode{{ i }}" class="form-control ps-5" formControlName="parcelCode"
                          [class.is-invalid]="isFieldInvalid('parcels.' + i + '.parcelCode')"
                          [placeholder]="getFieldPlaceholder('parcelCode', 'SHIPMENT_REQUEST.PARCEL_CODE_AUTO_PLACEHOLDER' | translate)">
                        <i class="fas fa-cube position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                      </div>
                      <div class="invalid-feedback" *ngIf="isFieldInvalid('parcels.' + i + '.parcelCode')">
                        {{ getFieldError('parcels.' + i + '.parcelCode') }}
                      </div>
                    </div>

                    <!-- Description Row -->
                    <div class="col-md-12 mb-3">
                      <label for="parcelDescription{{ i }}" class="form-label">{{ 'SHIPMENT_REQUEST.PARCEL_DESCRIPTION'
                        | translate }}<span *ngIf="isFieldRequired('parcelDescription')" class="text-danger ms-1">*</span></label>
                      <div class="position-relative">
                        <input type="text" id="parcelDescription{{ i }}" class="form-control ps-5"
                          formControlName="parcelDescription" maxlength="40"
                          [class.is-invalid]="isFieldInvalid('parcels.' + i + '.parcelDescription')"
                          [placeholder]="getFieldPlaceholder('parcelDescription', 'SHIPMENT_REQUEST.PARCEL_DESCRIPTION_PLACEHOLDER' | translate)"
                          (input)="onParcelDescriptionChange($event, i)">
                        <i
                          class="fas fa-file-alt position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                      </div>
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="invalid-feedback" *ngIf="isFieldInvalid('parcels.' + i + '.parcelDescription')">
                          {{ getFieldError('parcels.' + i + '.parcelDescription') }}
                        </div>
                        <small class="text-muted mt-1"
                          [class.text-danger]="shipmentForm.get('parcels.' + i + '.parcelDescription')?.value?.length > 40">
                          {{ shipmentForm.get('parcels.' + i + '.parcelDescription')?.value?.length || 0 }}/40
                        </small>
                      </div>
                    </div><!-- Second Row: Weight, Volume, Insured Value -->
                    <div class="col-md-4 mb-3">
                      <label for="parcelWeight{{ i }}" class="form-label">{{ 'SHIPMENT_REQUEST.WEIGHT' | translate }}
                        (kg)<span *ngIf="isFieldRequired('parcelWeight')" class="text-danger ms-1">*</span></label>
                      <div class="position-relative">
                        <input type="number" id="parcelWeight{{ i }}" class="form-control ps-5"
                          formControlName="parcelWeight" step="0.001" min="0.001" max="99999.999"
                          [class.is-invalid]="isFieldInvalid('parcels.' + i + '.parcelWeight')"
                          [placeholder]="getFieldPlaceholder('parcelWeight', 'es. 0.001')">
                        <i
                          class="fas fa-weight-hanging position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                      </div>
                      <div class="invalid-feedback" *ngIf="isFieldInvalid('parcels.' + i + '.parcelWeight')">
                        {{ getFieldError('parcels.' + i + '.parcelWeight') }}
                      </div>
                    </div>
                    <div class="col-md-4 mb-3">
                      <label for="parcelVolume{{ i }}" class="form-label">{{ 'SHIPMENT_REQUEST.VOLUME' | translate }}
                        (m³)<span *ngIf="isFieldRequired('parcelVolume')" class="text-danger ms-1">*</span></label>
                      <div class="position-relative">
                        <input type="number" id="parcelVolume{{ i }}" class="form-control ps-5"
                          formControlName="parcelVolume" step="0.0001" min="0.0001" max="99999.9999"
                          [class.is-invalid]="isFieldInvalid('parcels.' + i + '.parcelVolume')"
                          [placeholder]="getFieldPlaceholder('parcelVolume', 'es. 0.0001')"
                          (input)="onDimensionChange(i)">
                        <i
                          class="fas fa-expand-arrows-alt position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                      </div>
                      <div class="invalid-feedback" *ngIf="isFieldInvalid('parcels.' + i + '.parcelVolume')">
                        {{ getFieldError('parcels.' + i + '.parcelVolume') }}
                      </div>
                    </div>
                    <div class="col-md-4 mb-3">
                      <label for="parcelInsuredValue{{ i }}" class="form-label">{{ 'SHIPMENT_REQUEST.INSURED_VALUE' |
                        translate }} (€)</label>
                      <div class="position-relative">
                        <input type="number" id="parcelInsuredValue{{ i }}" class="form-control ps-5"
                          formControlName="parcelInsuredValue" step="0.01" min="0" max="99999.99"
                          [class.is-invalid]="isFieldInvalid('parcels.' + i + '.parcelInsuredValue')"
                          placeholder="es. 5000.00">
                        <i
                          class="fas fa-euro-sign position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                      </div>
                      <div class="invalid-feedback" *ngIf="isFieldInvalid('parcels.' + i + '.parcelInsuredValue')">
                        {{ getFieldError('parcels.' + i + '.parcelInsuredValue') }}
                      </div>
                    </div><!-- Third Row: Dimensions -->
                    <div class="col-md-4 mb-3">
                      <label for="parcelLength{{ i }}" class="form-label">{{ 'SHIPMENT_REQUEST.LENGTH' | translate }}
                        (cm)<span *ngIf="isFieldRequired('parcelDimensions')" class="text-danger ms-1">*</span></label>
                      <div class="position-relative">
                        <input type="number" id="parcelLength{{ i }}" class="form-control ps-5"
                          formControlName="parcelLength"
                          [class.is-invalid]="isFieldInvalid('parcels.' + i + '.parcelLength')" step="0.1" min="0"
                          max="99999.9" [placeholder]="getFieldPlaceholder('parcelDimensions', 'es. 1.0')"
                          (input)="onDimensionChange(i)">
                        <i
                          class="fas fa-ruler-horizontal position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                      </div>
                      <div class="invalid-feedback" *ngIf="isFieldInvalid('parcels.' + i + '.parcelLength')">
                        {{ getFieldError('parcels.' + i + '.parcelLength') }}
                      </div>
                    </div>
                    <div class="col-md-4 mb-3">
                      <label for="parcelWidth{{ i }}" class="form-label">{{ 'SHIPMENT_REQUEST.WIDTH' | translate }}
                        (cm)<span *ngIf="isFieldRequired('parcelDimensions')" class="text-danger ms-1">*</span></label>
                      <div class="position-relative">
                        <input type="number" id="parcelWidth{{ i }}" class="form-control ps-5"
                          formControlName="parcelWidth"
                          [class.is-invalid]="isFieldInvalid('parcels.' + i + '.parcelWidth')" step="0.1" min="0"
                          max="99999.9" [placeholder]="getFieldPlaceholder('parcelDimensions', 'es. 1.0')"
                          (input)="onDimensionChange(i)">
                        <i
                          class="fas fa-ruler-vertical position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                      </div>
                      <div class="invalid-feedback" *ngIf="isFieldInvalid('parcels.' + i + '.parcelWidth')">
                        {{ getFieldError('parcels.' + i + '.parcelWidth') }}
                      </div>
                    </div>
                    <div class="col-md-4 mb-3">
                      <label for="parcelHeight{{ i }}" class="form-label">{{ 'SHIPMENT_REQUEST.HEIGHT' | translate }}
                        (cm)<span *ngIf="isFieldRequired('parcelDimensions')" class="text-danger ms-1">*</span></label>
                      <div class="position-relative">
                        <input type="number" id="parcelHeight{{ i }}" class="form-control ps-5"
                          formControlName="parcelHeight"
                          [class.is-invalid]="isFieldInvalid('parcels.' + i + '.parcelHeight')" step="0.1" min="0"
                          max="99999.9" [placeholder]="getFieldPlaceholder('parcelDimensions', 'es. 1.0')"
                          (input)="onDimensionChange(i)">
                        <i class="fas fa-ruler position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                      </div>
                      <div class="invalid-feedback" *ngIf="isFieldInvalid('parcels.' + i + '.parcelHeight')">
                        {{ getFieldError('parcels.' + i + '.parcelHeight') }}
                      </div>
                    </div>

                    <!-- Volume Validation Message -->
                    <div class="col-12" *ngIf="getParcelVolumeValidation(i) as volumeValidation">
                      <!-- Success message (volume matches) -->
                      <div *ngIf="volumeValidation.type === 'match'" class="alert alert-success d-flex align-items-center mt-2 mb-0 small">
                        <i class="fas fa-check-circle me-2"></i>
                        <strong>{{ volumeValidation.message | translate:{ calculated: (volumeValidation.calculatedVolume | number:'1.4-4') } }}</strong>
                      </div>

                      <!-- Warning message (volume mismatch) -->
                      <div *ngIf="volumeValidation.type === 'mismatch'" class="alert alert-warning d-flex align-items-center mt-2 mb-0 small">
                        <i class="fas fa-exclamation-triangle me-2"></i>
                        <div class="flex-grow-1">
                          <strong>{{ volumeValidation.message | translate:{ calculated: (volumeValidation.calculatedVolume | number:'1.4-4'), entered: (volumeValidation.enteredVolume | number:'1.4-4') } }}</strong>
                        </div>
                        <button type="button" class="btn btn-outline-warning btn-sm ms-2" (click)="useCalculatedVolume(i)">
                          {{ 'SHIPMENT_REQUEST.VOLUME_VALIDATION.USE_CALCULATED' | translate }}
                        </button>
                      </div>

                      <!-- Info message (volume missing) -->
                      <div *ngIf="volumeValidation.type === 'missing'" class="alert alert-info d-flex align-items-center mt-2 mb-0 small">
                        <i class="fas fa-info-circle me-2"></i>
                        <div class="flex-grow-1">
                          <strong>{{ volumeValidation.message | translate:{ calculated: (volumeValidation.calculatedVolume | number:'1.4-4') } }}</strong>
                        </div>
                        <button type="button" class="btn btn-outline-info btn-sm ms-2" (click)="useCalculatedVolume(i)">
                          {{ 'SHIPMENT_REQUEST.VOLUME_VALIDATION.USE_CALCULATED' | translate }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Riassunto e pulsante -->
            <div class="d-flex justify-content-between align-items-center mt-3">
              <!-- Riassunto parametri colli sulla sinistra -->
              <div class="d-flex align-items-center">
                <div class="d-flex gap-4">
                  <span>
                    <small class="text-muted">{{ 'SHIPMENT_REQUEST.TOTAL_PARCELS' | translate }}:</small>
                    <span class="fw-bold text-primary ms-1">{{ parcelsArray.length || '-' }}</span>
                  </span>
                  <span>
                    <small class="text-muted">{{ 'SHIPMENT_REQUEST.TOTAL_WEIGHT' | translate }}:</small>
                    <span class="fw-bold text-primary ms-1">{{ getCurrentParcelsWeight() > 0 ?
                      (getCurrentParcelsWeight() | number:'1.1-2') + ' kg' : '-' }}</span>
                  </span> <span>
                    <small class="text-muted">{{ 'SHIPMENT_REQUEST.TOTAL_VOLUME' | translate }}:</small>
                    <span class="fw-bold text-primary ms-1">{{ getCurrentParcelsVolume() > 0 ?
                      (getCurrentParcelsVolume() | number:'1.4-4') + ' m³' : '-' }}</span>
                  </span>
                  <span>
                    <small class="text-muted">{{ 'SHIPMENT_REQUEST.TOTAL_INSURED_VALUE' | translate }}:</small>
                    <span class="fw-bold text-primary ms-1">{{ getCurrentParcelsInsuredValue() > 0 ?
                      (getCurrentParcelsInsuredValue() | number:'1.2-2') + ' €' : '-' }}</span>
                  </span>
                </div>
              </div>

              <!-- Pulsanti Aggiungi Collo e Reset Colli sulla destra -->
              <div class="d-flex gap-2">
                <button 
                  type="button" 
                  class="btn btn-outline-secondary" 
                  (click)="resetParcels()"
                  [disabled]="parcelsArray.length <= 1"
                  [title]="'SHIPMENT_REQUEST.RESET_PARCELS' | translate">
                  <i class="fas fa-undo me-2"></i>
                  {{ 'SHIPMENT_REQUEST.RESET_PARCELS' | translate }}
                </button>
                
                <button 
                  type="button" 
                  class="btn btn-primary" 
                  (click)="addParcel()"
                  [disabled]="isMaxParcelsReached()"
                  [title]="isMaxParcelsReached() ? ('SHIPMENT_REQUEST.MAX_PARCELS_REACHED' | translate) : ''">
                  <i class="fas fa-plus me-2"></i>
                  {{ 'SHIPMENT_REQUEST.ADD_PARCEL' | translate }}
                </button>
              
                
                <!-- Warning message when approaching limit -->
                <div *ngIf="isApproachingMaxParcels()" class="alert alert-warning mt-2 mb-0 small">
                  <i class="fas fa-exclamation-triangle me-1"></i>
                  {{ 'SHIPMENT_REQUEST.APPROACHING_MAX_PARCELS' | translate }}
                </div>
                
                <!-- Error message when limit reached -->
                <div *ngIf="isMaxParcelsReached()" class="alert alert-danger mt-2 mb-0 small">
                  <i class="fas fa-times-circle me-1"></i>
                  {{ 'SHIPMENT_REQUEST.MAX_PARCELS_REACHED' | translate }}
                </div>
              </div>
            </div>
          </div>
        </div> <!-- Sezione 3: Dati Anagrafici Destinazione -->
        <div class="card form-section">
          <div class="card-header">
            <div class="d-flex justify-content-between align-items-center w-100">
              <div class="header-title">
                <i class="fas fa-map-marker-alt header-icon"></i>
                <h3>{{ 'SHIPMENT_REQUEST.DESTINATION_DATA' | translate }}</h3>
              </div>
              <div class="d-flex gap-2" *ngIf="currentFieldSettings?.fields?.['dealerManagement']?.enabled === true">
                <button type="button" class="btn btn-outline-primary"
                        (click)="openDealerEditPopup()"
                        [disabled]="!isDealerSelected"
                        title="Modifica dealer selezionato">
                  <i class="fas fa-user-edit me-1"></i>
                  Modifica Dealer
                </button>
                <button type="button" class="btn btn-primary"
                        (click)="openDealerCreatePopup()"
                        title="Inserisci nuovo dealer">
                  <i class="fas fa-user-plus me-1"></i>
                  Nuovo Dealer
                </button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <!-- Dealer Selection Status Alert -->
            <div class="alert alert-info d-flex align-items-center mb-3" *ngIf="isDealerSelected">
              <i class="fas fa-lock me-2"></i>
              <span>{{ 'SHIPMENT_REQUEST.DEALER_SELECTED_MESSAGE' | translate }}</span>
              <!-- <button type="button" class="btn btn-sm btn-outline-info ms-auto" (click)="clearDealerSelection()">
            <i class="fas fa-unlock me-1"></i>
            {{ 'SHIPMENT_REQUEST.UNLOCK_FIELDS' | translate }}
          </button> -->
            </div>

            <div formGroupName="destination"> <!-- Dati Principali Dealer -->
              <div class="row">
                <div class="col-md-4 mb-3">
                  <label for="dealerCode" class="form-label">{{ 'SHIPMENT_REQUEST.DEALER_CODE' | translate }} *</label>
                  <div class="position-relative">
                    <input type="text" id="dealerCode" class="form-control ps-5" formControlName="dealerCode"
                      [class.is-invalid]="isFieldInvalid('destination.dealerCode')"
                      placeholder="{{ 'SHIPMENT_REQUEST.DEALER_CODE_PLACEHOLDER' | translate }}"
                      (input)="onDealerCodeInput($event)" (blur)="hideSuggestions('code')" autocomplete="off">
                    <i class="fas fa-user-tie position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                    <!-- Suggestions dropdown for dealer code -->
                    <div class="autocomplete-suggestions show" *ngIf="showDealerCodeSuggestions">
                      <button type="button" class="dropdown-item d-flex justify-content-between align-items-center"
                        *ngFor="let dealer of dealerCodeSuggestions" (click)="selectDealerFromCode(dealer)">
                        <div>
                          <strong>{{ dealer.dealerCode }}</strong>
                          <br>
                          <small class="text-muted">{{ dealer.dealerName }}</small>
                        </div>
                        <small class="text-muted">{{ dealer.dealerVatNumber }}</small>
                      </button>
                      <div class="dropdown-item-text text-muted text-center"
                        *ngIf="dealerCodeSuggestions.length === 0 && isClientBrandSelected">
                        {{ 'SHIPMENT_REQUEST.NO_RESULTS_FOUND' | translate }}
                      </div>
                      <div class="dropdown-item-text text-warning text-center" *ngIf="!isClientBrandSelected">
                        {{ 'SHIPMENT_REQUEST.NO_BRAND_OR_CLIENT_SELECTED' | translate }}
                      </div>
                    </div>
                  </div>
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('destination.dealerCode')">
                    {{ getFieldError('destination.dealerCode') }}
                  </div>
                </div>
                <div class="col-md-8 mb-3">
                  <label for="dealerName" class="form-label">{{ 'SHIPMENT_REQUEST.COMPANY_NAME' | translate }} *</label>
                  <div class="position-relative">
                    <input type="text" id="dealerName" class="form-control ps-5" formControlName="dealerName"
                      [class.is-invalid]="isFieldInvalid('destination.dealerName')"
                      placeholder="{{ 'SHIPMENT_REQUEST.COMPANY_NAME_PLACEHOLDER' | translate }}"
                      (input)="onDealerNameInput($event)" (blur)="hideSuggestions('name')" autocomplete="off">
                    <i class="fas fa-building position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                    <!-- Suggestions dropdown for dealer name -->
                    <div class="autocomplete-suggestions show" *ngIf="showDealerNameSuggestions">
                      <button type="button" class="dropdown-item d-flex justify-content-between align-items-center"
                        *ngFor="let dealer of dealerNameSuggestions" (click)="selectDealerFromName(dealer)">
                        <div>
                          <strong>{{ dealer.dealerName }}</strong>
                          <br>
                          <small class="text-muted">{{ dealer.dealerCode }}</small>
                        </div>
                        <small class="text-muted">{{ dealer.dealerVatNumber }}</small>
                      </button>
                      <div class="dropdown-item-text text-muted text-center"
                        *ngIf="dealerNameSuggestions.length === 0 && isClientBrandSelected">
                        {{ 'SHIPMENT_REQUEST.NO_RESULTS_FOUND' | translate }}
                      </div>
                      <div class="dropdown-item-text text-warning text-center" *ngIf="!isClientBrandSelected">
                        {{ 'SHIPMENT_REQUEST.NO_BRAND_OR_CLIENT_SELECTED' | translate }}
                      </div>
                    </div>
                  </div>
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('destination.dealerName')">
                    {{ getFieldError('destination.dealerName') }}
                  </div>
                </div>
              </div><!-- Seconda riga: Contatti e dati fiscali -->
              <div class="row">
                <div class="col-md-4 mb-3">
                  <label for="dealerVatNumber" class="form-label">{{ 'SHIPMENT_REQUEST.VAT_NUMBER' | translate
                    }}</label>
                  <div class="position-relative">
                    <input type="text" id="dealerVatNumber" class="form-control ps-5" formControlName="dealerVatNumber"
                      placeholder="es. {{ 'SHIPMENT_REQUEST.VAT_NUMBER_PLACEHOLDER' | translate }}"
                      (input)="onDealerVatInput($event)" (blur)="hideSuggestions('vat')" autocomplete="off">
                    <i class="fas fa-receipt position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                    <!-- Suggestions dropdown for VAT number -->
                    <div class="autocomplete-suggestions show" *ngIf="showDealerVatSuggestions">
                      <button type="button" class="dropdown-item d-flex justify-content-between align-items-center"
                        *ngFor="let dealer of dealerVatSuggestions" (click)="selectDealerFromVat(dealer)">
                        <div>
                          <strong>{{ dealer.dealerVatNumber }}</strong>
                          <br>
                          <small class="text-muted">{{ dealer.dealerName }}</small>
                        </div>
                        <small class="text-muted">{{ dealer.dealerCode }}</small>
                      </button>
                      <div class="dropdown-item-text text-muted text-center"
                        *ngIf="dealerVatSuggestions.length === 0 && isClientBrandSelected">
                        {{ 'SHIPMENT_REQUEST.NO_RESULTS_FOUND' | translate }}
                      </div>
                      <div class="dropdown-item-text text-warning text-center" *ngIf="!isClientBrandSelected">
                        {{ 'SHIPMENT_REQUEST.NO_BRAND_OR_CLIENT_SELECTED' | translate }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 mb-3">
                  <label for="dealerOperatingPhone" class="form-label">
                    {{ 'SHIPMENT_REQUEST.PHONE' | translate }}
                    <i class="fas fa-lock text-muted ms-1" *ngIf="isDealerFieldDisabled('dealerOperatingPhone')"
                      title="Campo bloccato - Dealer selezionato"></i>
                  </label>
                  <div class="position-relative">
                    <input type="tel" id="dealerOperatingPhone" class="form-control ps-5"
                      formControlName="dealerOperatingPhone"
                      [class.bg-light]="isDealerFieldDisabled('dealerOperatingPhone')"
                      placeholder="es. {{ 'SHIPMENT_REQUEST.PHONE_PLACEHOLDER' | translate }}">
                    <i class="fas fa-phone position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                  </div>
                </div>
                <div class="col-md-4 mb-3">
                  <label for="dealerOperatingEmail" class="form-label">
                    {{ 'SHIPMENT_REQUEST.EMAIL' | translate }}
                    <i class="fas fa-lock text-muted ms-1" *ngIf="isDealerFieldDisabled('dealerOperatingEmail')"
                      title="Campo bloccato - Dealer selezionato"></i>
                  </label>
                  <div class="position-relative">
                    <input type="email" id="dealerOperatingEmail" class="form-control ps-5"
                      formControlName="dealerOperatingEmail"
                      [class.bg-light]="isDealerFieldDisabled('dealerOperatingEmail')"
                      [class.is-invalid]="isFieldInvalid('destination.dealerOperatingEmail')"
                      placeholder="es. {{ 'SHIPMENT_REQUEST.EMAIL_PLACEHOLDER' | translate }}">
                    <i class="fas fa-envelope position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                  </div>
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('destination.dealerOperatingEmail')">
                    {{ getFieldError('destination.dealerOperatingEmail') }}
                  </div>
                </div>
              </div>

              <!-- Indirizzo Operativo -->
              <div class="mt-4">
                <h5 class="mb-3">
                  <i class="fas fa-map-marker-alt me-2"></i>
                  {{ 'SHIPMENT_REQUEST.OPERATING_ADDRESS' | translate }}
                </h5>
                <div class="row">
                  <div class="col-md-8 mb-3">
                    <label for="dealerOperatingAddressStreet" class="form-label">
                      {{ 'SHIPMENT_REQUEST.STREET' | translate }} *
                      <i class="fas fa-lock text-muted ms-1"
                        *ngIf="isDealerFieldDisabled('dealerOperatingAddressStreet')"
                        title="Campo bloccato - Dealer selezionato"></i>
                    </label>
                    <div class="position-relative">
                      <input type="text" id="dealerOperatingAddressStreet" class="form-control ps-5"
                        formControlName="dealerOperatingAddressStreet"
                        [class.bg-light]="isDealerFieldDisabled('dealerOperatingAddressStreet')"
                        [class.is-invalid]="isFieldInvalid('destination.dealerOperatingAddressStreet')"
                        placeholder="{{ 'SHIPMENT_REQUEST.STREET_PLACEHOLDER' | translate }}">
                      <i class="fas fa-road position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                    </div>
                    <div class="invalid-feedback" *ngIf="isFieldInvalid('destination.dealerOperatingAddressStreet')">
                      {{ getFieldError('destination.dealerOperatingAddressStreet') }}
                    </div>
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="dealerOperatingAddressNumber" class="form-label">
                      {{ 'SHIPMENT_REQUEST.NUMBER' | translate }} *
                      <i class="fas fa-lock text-muted ms-1"
                        *ngIf="isDealerFieldDisabled('dealerOperatingAddressNumber')"
                        title="Campo bloccato - Dealer selezionato"></i>
                    </label>
                    <div class="position-relative">
                      <input type="text" id="dealerOperatingAddressNumber" class="form-control ps-5"
                        formControlName="dealerOperatingAddressNumber"
                        [class.bg-light]="isDealerFieldDisabled('dealerOperatingAddressNumber')"
                        [class.is-invalid]="isFieldInvalid('destination.dealerOperatingAddressNumber')"
                        placeholder="es. 123">
                      <i class="fas fa-hashtag position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                    </div>
                    <div class="invalid-feedback" *ngIf="isFieldInvalid('destination.dealerOperatingAddressNumber')">
                      {{ getFieldError('destination.dealerOperatingAddressNumber') }}
                    </div>
                  </div>
                  <div class="col-md-3 mb-3">
                    <label for="dealerOperatingAddressZip" class="form-label">
                      {{ 'SHIPMENT_REQUEST.ZIP' | translate }} *
                      <i class="fas fa-lock text-muted ms-1" *ngIf="isDealerFieldDisabled('dealerOperatingAddressZip')"
                        title="Campo bloccato - Dealer selezionato"></i>
                    </label>
                    <div class="position-relative">
                      <input type="text" id="dealerOperatingAddressZip" class="form-control ps-5"
                        formControlName="dealerOperatingAddressZip"
                        [class.bg-light]="isDealerFieldDisabled('dealerOperatingAddressZip')"
                        [class.is-invalid]="isFieldInvalid('destination.dealerOperatingAddressZip')"
                        placeholder="es. 12345">
                      <i
                        class="fas fa-mail-bulk position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                    </div>
                    <div class="invalid-feedback" *ngIf="isFieldInvalid('destination.dealerOperatingAddressZip')">
                      {{ getFieldError('destination.dealerOperatingAddressZip') }}
                    </div>
                  </div>
                  <div class="col-md-5 mb-3">
                    <label for="dealerOperatingAddressCity" class="form-label">
                      {{ 'SHIPMENT_REQUEST.CITY' | translate }} *
                      <i class="fas fa-lock text-muted ms-1" *ngIf="isDealerFieldDisabled('dealerOperatingAddressCity')"
                        title="Campo bloccato - Dealer selezionato"></i>
                    </label>
                    <div class="position-relative">
                      <input type="text" id="dealerOperatingAddressCity" class="form-control ps-5"
                        formControlName="dealerOperatingAddressCity"
                        [class.bg-light]="isDealerFieldDisabled('dealerOperatingAddressCity')"
                        [class.is-invalid]="isFieldInvalid('destination.dealerOperatingAddressCity')"
                        placeholder="{{ 'SHIPMENT_REQUEST.CITY_PLACEHOLDER' | translate }}">
                      <i class="fas fa-city position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                    </div>
                    <div class="invalid-feedback" *ngIf="isFieldInvalid('destination.dealerOperatingAddressCity')">
                      {{ getFieldError('destination.dealerOperatingAddressCity') }}
                    </div>
                  </div>
                  <div class="col-md-2 mb-3">
                    <label for="dealerOperatingAddressProvince" class="form-label">
                      {{ 'SHIPMENT_REQUEST.PROVINCE' | translate }} *
                      <i class="fas fa-lock text-muted ms-1"
                        *ngIf="isDealerFieldDisabled('dealerOperatingAddressProvince')"
                        title="Campo bloccato - Dealer selezionato"></i>
                    </label>
                    <div class="position-relative">
                      <input type="text" id="dealerOperatingAddressProvince" class="form-control ps-5"
                        formControlName="dealerOperatingAddressProvince"
                        [class.bg-light]="isDealerFieldDisabled('dealerOperatingAddressProvince')"
                        [class.is-invalid]="isFieldInvalid('destination.dealerOperatingAddressProvince')"
                        placeholder="es. MI">
                      <i class="fas fa-map position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                    </div>
                    <div class="invalid-feedback" *ngIf="isFieldInvalid('destination.dealerOperatingAddressProvince')">
                      {{ getFieldError('destination.dealerOperatingAddressProvince') }}
                    </div>
                  </div>
                  <div class="col-md-2 mb-3">
                    <label for="dealerOperatingAddressCountry" class="form-label">
                      {{ 'SHIPMENT_REQUEST.COUNTRY' | translate }} *
                      <i class="fas fa-lock text-muted ms-1"
                        *ngIf="isDealerFieldDisabled('dealerOperatingAddressCountry')"
                        title="Campo bloccato - Dealer selezionato"></i>
                    </label>
                    <div class="position-relative">
                      <input type="text" id="dealerOperatingAddressCountry" class="form-control ps-5"
                        formControlName="dealerOperatingAddressCountry"
                        [class.bg-light]="isDealerFieldDisabled('dealerOperatingAddressCountry')"
                        [class.is-invalid]="isFieldInvalid('destination.dealerOperatingAddressCountry')"
                        placeholder="es. IT">
                      <i class="fas fa-flag position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                    </div>
                    <div class="invalid-feedback" *ngIf="isFieldInvalid('destination.dealerOperatingAddressCountry')">
                      {{ getFieldError('destination.dealerOperatingAddressCountry') }}
                    </div>
                  </div>
                </div>
                <!-- Dealer availability information -->
                <div class="alert alert-info d-flex align-items-center mb-3" *ngIf="isClientBrandSelected">
                  <i class="fas fa-info-circle me-2"></i>
                  <span *ngIf="availableDealersCount === 0">{{ 'SHIPMENT_REQUEST.NO_DEALERS_MESSAGE' | translate
                    }}</span>
                  <span *ngIf="availableDealersCount === 1">{{ 'SHIPMENT_REQUEST.DEALERS_COUNT_SINGLE_MESSAGE' |
                    translate }}</span>
                  <span *ngIf="availableDealersCount > 1">{{ 'SHIPMENT_REQUEST.DEALERS_COUNT_MESSAGE' | translate:{
                    count: availableDealersCount } }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Pulsanti di azione -->
        <div class="d-flex justify-content-end gap-3 mt-4">
          <button type="button" class="btn btn-outline-secondary" (click)="resetForm()">
            <i class="fas fa-undo me-2"></i>
            {{ 'SHIPMENT_REQUEST.RESET' | translate }}
          </button>
          <button type="submit" class="btn btn-primary" [disabled]="!shipmentForm.valid || isSubmitting">
            <i class="fas me-2"
              [ngClass]="isSubmitting ? 'fa-spinner fa-spin' : (editingWaybillId ? 'fa-save' : 'fa-plus')"></i>
            <span *ngIf="!isSubmitting">
              {{ editingWaybillId ? ('SHIPMENT_REQUEST.UPDATE_WAYBILL' | translate) : ('SHIPMENT_REQUEST.ADD_WAYBILL' |
              translate) }}
            </span>
            <span *ngIf="isSubmitting">
              {{ editingWaybillId ? ('SHIPMENT_REQUEST.UPDATING' | translate) : ('SHIPMENT_REQUEST.ADDING' | translate)
              }}
            </span>
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Sezione Riepilogo (sempre visibile) -->
  <div class="card mt-4">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center">
        <div class="header-title">
          <i class="fas fa-chart-pie header-icon"></i>
          <h3>{{ 'SHIPMENT_REQUEST.SUMMARY' | translate }}</h3>
        </div>
        <!-- Pulsante per la stampa del borderò - TEMPORANEAMENTE COMMENTATO -->
        <!--
        <button type="button" class="btn btn-outline-primary btn-sm" (click)="generateDailySummaryPDF()"
          [title]="'SHIPMENT_REQUEST.PRINT_DAILY_SUMMARY' | translate">
          <i class="fas fa-file-pdf me-2"></i>
          {{ 'SHIPMENT_REQUEST.PRINT_BORDERO' | translate }}
        </button>
        -->
      </div>
    </div>
    <div class="card-body">
      <div class="sm-metrics-grid">

        <!-- Totale bolle -->
        <div class="sm-metric-card">
          <div class="sm-metric-icon sm-metric-icon--blue">
            <i class="fas fa-file-alt"></i>
          </div>
          <div class="sm-metric-body">
            <div class="sm-metric-value">{{ getSummary().totalShipments }}</div>
            <div class="sm-metric-label">{{ 'SHIPMENT_REQUEST.TOTAL_WAYBILLS' | translate }}</div>
          </div>
        </div>

        <!-- Totale colli -->
        <div class="sm-metric-card">
          <div class="sm-metric-icon sm-metric-icon--purple">
            <i class="fas fa-boxes"></i>
          </div>
          <div class="sm-metric-body">
            <div class="sm-metric-value">{{ getSummary().totalParcels }}</div>
            <div class="sm-metric-label">{{ 'SHIPMENT_REQUEST.TOTAL_PARCELS' | translate }}</div>
          </div>
        </div>

        <!-- Peso totale -->
        <div class="sm-metric-card">
          <div class="sm-metric-icon sm-metric-icon--orange">
            <i class="fas fa-weight-hanging"></i>
          </div>
          <div class="sm-metric-body">
            <div class="sm-metric-value">
              {{ getSummary().totalWeight | number:'1.2-2' }}<span class="sm-metric-unit">kg</span>
            </div>
            <div class="sm-metric-label">{{ 'SHIPMENT_REQUEST.TOTAL_WEIGHT' | translate }}</div>
          </div>
        </div>

        <!-- Volume totale -->
        <div class="sm-metric-card">
          <div class="sm-metric-icon sm-metric-icon--yellow">
            <i class="fas fa-cube"></i>
          </div>
          <div class="sm-metric-body">
            <div class="sm-metric-value">
              {{ getSummary().totalVolume | number:'1.4-4' }}<span class="sm-metric-unit">m³</span>
            </div>
            <div class="sm-metric-label">{{ 'SHIPMENT_REQUEST.TOTAL_VOLUME' | translate }}</div>
          </div>
        </div>

        <!-- Valore assicurato -->
        <div class="sm-metric-card">
          <div class="sm-metric-icon sm-metric-icon--green">
            <i class="fas fa-shield-alt"></i>
          </div>
          <div class="sm-metric-body">
            <div class="sm-metric-value">
              {{ getSummary().totalInsuredValue | number:'1.2-2' }}<span class="sm-metric-unit">€</span>
            </div>
            <div class="sm-metric-label">{{ 'SHIPMENT_REQUEST.TOTAL_INSURED_VALUE' | translate }}</div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- Sezione Borderò -->
  <div *ngIf="showBorderoSection" class="card mt-4">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center">
        <div class="header-title">
          <i class="fas fa-clipboard-list header-icon"></i>
          <h3>Borderò</h3>
        </div>
        <span class="badge bg-secondary">
          {{ borderoGrouped.length }} destinazioni
        </span>
      </div>
    </div>
    <div class="card-body p-0">

      <!-- Suddivisione per zone del cliente (permesso special sulla funzione borderò) -->
      <div class="bordero-zone-split" *ngIf="showBorderoZoneSplitOption">
        <div class="bordero-zone-split-text">
          <span class="bordero-zone-split-title">
            <i class="fas fa-map-marked-alt me-2"></i>Suddividi per Zone del Dealer
          </span>
          <span class="bordero-zone-split-hint">
            Raggruppa il borderò secondo le zone configurate per il dealer
          </span>
        </div>

        <button type="button"
                class="bordero-zone-toggle"
                role="switch"
                [class.active]="splitBorderoByClientZones"
                [attr.aria-checked]="splitBorderoByClientZones"
                [disabled]="isBorderoLoading"
                (click)="toggleSplitBorderoByClientZones()"
                [title]="splitBorderoByClientZones ? 'Suddivisione attiva' : 'Suddivisione disattiva'">
          <span class="bordero-zone-toggle-knob"></span>
        </button>
      </div>

      <div class="table-responsive">
        <table class="table align-middle mb-0">
          <thead class="table-light">
            <tr>
              <th class="ps-3" style="width: 200px;">Codice Borderò</th>
              <th>Origine</th>
              <th>Destinazione</th>
              <th *ngIf="showBorderoZoneSplitOption" style="width: 120px;">Zona Dealer</th>
              <th style="width: 220px;">Avanzamento</th>
              <th class="text-center" style="width: 80px;">Stato</th>
              <th style="width: 1%; white-space: nowrap;">Data</th>
              <th style="width: 140px;"></th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="isBorderoLoading">
              <tr>
                <td [attr.colspan]="borderoColumnCount" class="text-center py-4">
                  <div class="spinner-border spinner-border-sm me-2" role="status"></div>
                  Caricamento...
                </td>
              </tr>
            </ng-container>
            <ng-container *ngIf="!isBorderoLoading">
              <tr *ngFor="let g of borderoGrouped"
                [ngClass]="g.status === 'COMPLETED' ? 'bordero-row--completato' : 'bordero-row--attesa'">

                <!-- Codice Borderò -->
                <td class="ps-3">
                  <span class="fw-semibold font-monospace">{{ g.borderoCodice || '—' }}</span>
                </td>

                <!-- Origine -->
                <td>
                  <div *ngIf="g.warehouseFromName" class="fw-semibold">{{ g.warehouseFromName }}</div>
                  <div class="text-muted small">{{ g.warehouseFrom || '—' }}</div>
                </td>

                <!-- Destinazione -->
                <td>
                  <div *ngIf="g.warehouseToName" class="fw-semibold">{{ g.warehouseToName }}</div>
                  <div class="text-muted small">{{ g.warehouseTo || '—' }}</div>
                </td>

                <!-- Zona del dealer (NORD / CENTRO / SUD) -->
                <td *ngIf="showBorderoZoneSplitOption">
                  <span *ngIf="g.clientZone" class="bordero-zone-badge">
                    <i class="fas fa-map-marker-alt me-1"></i>{{ g.clientZone }}
                  </span>
                  <span *ngIf="!g.clientZone" class="text-muted small"
                        title="Nessuna zona configurata per questo concessionario">—</span>
                </td>

                <!-- Progress bar -->
                <td>
                  <div class="bordero-bar">
                    <div class="bordero-bar__track">
                      <div class="bordero-bar__fill"
                        [style.width.%]="g.totalParcels > 0 ? (g.deliveredParcels / g.totalParcels) * 100 : 0"
                        [ngClass]="{
                          'bordero-bar__fill--success': g.deliveredParcels === g.totalParcels && g.totalParcels > 0,
                          'bordero-bar__fill--warning': g.deliveredParcels > 0 && g.deliveredParcels < g.totalParcels,
                          'bordero-bar__fill--danger':  g.deliveredParcels === 0
                        }">
                        <span class="bordero-bar__label">
                          {{ g.totalParcels > 0 ? ((g.deliveredParcels / g.totalParcels) * 100 | number:'1.0-0') : 0 }}%
                        </span>
                      </div>
                    </div>
                    <span class="bordero-bar__counter">{{ g.deliveredParcels }}&nbsp;/&nbsp;{{ g.totalParcels }} colli</span>
                  </div>
                </td>

                <!-- Stato -->
                <td class="text-center">
                  <span class="bordero-badge"
                    [ngClass]="{
                      'bordero-badge--completato': g.status === 'COMPLETED',
                      'bordero-badge--attesa':     g.status !== 'COMPLETED'
                    }">
                    <i class="fas me-1"
                      [ngClass]="g.status === 'COMPLETED' ? 'fa-check-circle' : g.status === 'IN_PROGRESS' ? 'fa-spinner' : 'fa-clock'"></i>
                    {{ g.status === 'COMPLETED' ? 'Completato' : g.status === 'IN_PROGRESS' ? 'In corso' : 'In attesa' }}
                  </span>
                </td>

                <!-- Data -->
                <td style="white-space: nowrap;">
                  <span class="text-muted small">
                    <i class="fas fa-calendar-alt me-1 opacity-50"></i>{{ g.date || '—' }}
                  </span>
                </td>

                <!-- Azioni -->
                <td class="text-end pe-3">
                  <button *ngIf="g.status !== 'COMPLETED'" type="button"
                    class="btn btn-sm bordero-action-btn"
                    [ngClass]="(isBorderoDateToday(g) && isBorderoWarehouseAllowed(g)) ? 'btn-primary' : 'btn-secondary'"
                    [disabled]="!isBorderoDateToday(g) || !isBorderoWarehouseAllowed(g) || editingWaybillId !== null || isGeneratingBordero(g)"
                    [title]="editingWaybillId !== null ? 'Salva o annulla la modifica della bolla prima di generare il borderò' : (!isBorderoWarehouseAllowed(g) ? 'Magazzino origine non abilitato per il tuo profilo' : (!isBorderoDateToday(g) ? 'Disponibile in data ' + g.date : ''))"
                    data-bs-placement="bottom"
                    (click)="isBorderoDateToday(g) && isBorderoWarehouseAllowed(g) && !editingWaybillId && onGeneraBordero(g)">
                    <span *ngIf="isGeneratingBordero(g)" class="spinner-border spinner-border-sm me-1" role="status"></span>
                    <i *ngIf="!isGeneratingBordero(g)" class="fas me-1" [ngClass]="(isBorderoDateToday(g) && isBorderoWarehouseAllowed(g)) ? 'fa-file-alt' : 'fa-ban'"></i>
                    {{ isGeneratingBordero(g) ? 'Generazione...' : ((isBorderoDateToday(g) && isBorderoWarehouseAllowed(g)) ? 'Genera Borderò' : 'Non disponibile') }}
                  </button>
                  <button *ngIf="g.status === 'COMPLETED'" type="button"
                    class="btn btn-success btn-sm bordero-action-btn"
                    [disabled]="stampingBordero.has(g.borderoCodice!)"
                    (click)="onStampaBordero(g)">
                    <span *ngIf="stampingBordero.has(g.borderoCodice!)" class="spinner-border spinner-border-sm me-1" role="status"></span>
                    <i *ngIf="!stampingBordero.has(g.borderoCodice!)" class="fas fa-print me-1"></i>
                    {{ stampingBordero.has(g.borderoCodice!) ? 'Stampa...' : 'Stampa' }}
                  </button>
                </td>
              </tr>

              <tr *ngIf="borderoGrouped.length === 0">
                <td [attr.colspan]="borderoColumnCount" class="text-center text-muted py-5">
                  <i class="fas fa-inbox fa-2x mb-2 d-block opacity-25"></i>
                  Nessun borderò disponibile per oggi
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Sezione 4: Tabella dei Dati Inseriti -->
  <div class="card mt-4">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center">
        <!-- Titolo e ricerca a sinistra -->
        <div class="d-flex align-items-center gap-3">
          <div class="header-title">
            <i class="fas fa-list header-icon"></i>
            <h3>{{ viewMode === 'waybill' ? ('SHIPMENT_REQUEST.SUBMITTED_WAYBILLS' | translate) :
              ('SHIPMENT_REQUEST.SUBMITTED_PARCELS' | translate) }}</h3>
          </div>

          <!-- Input di ricerca -->
          <div class="search-container">
            <div class="input-group input-group-sm">
              <span class="input-group-text">
                <i class="fas fa-search"></i>
              </span>
              <input type="text" class="form-control" [formControl]="searchControl"
                [placeholder]="'SHIPMENT_REQUEST.SEARCH_PLACEHOLDER' | translate"
                [title]="'SHIPMENT_REQUEST.SEARCH_TITLE' | translate">
              <button *ngIf="searchTerm" class="btn btn-outline-secondary btn-sm" type="button"
                (click)="clearSearch()" [title]="'SHIPMENT_REQUEST.CLEAR_SEARCH' | translate">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>
        <!-- Controlli a destra -->
        <div class="controls-container"> <!-- Excel Export Button -->
          <button *ngIf="!showBorderoSection" type="button" class="btn btn-success btn-sm me-2" (click)="exportToExcel()"
            [disabled]="isExportingExcel"
            [title]="(viewMode === 'waybill' ? 'SHIPMENT_REQUEST.EXPORT_WAYBILLS_EXCEL' : 'SHIPMENT_REQUEST.EXPORT_PARCELS_EXCEL') | translate">
            <i class="fas fa-file-excel me-1"></i>
            {{ isExportingExcel ? ('SHIPMENT_REQUEST.EXPORTING' | translate) : ('SHIPMENT_REQUEST.EXPORT_EXCEL' |
            translate) }}
          </button>

          <!-- View Mode Toggle -->
          <div class="btn-group btn-group-sm" role="group">
            <button type="button" class="btn btn-sm"
              [ngClass]="viewMode === 'waybill' ? 'btn-primary' : 'btn-outline-primary'" (click)="toggleViewMode()"
              [title]="'SHIPMENT_REQUEST.VIEW_BY_WAYBILL' | translate">
              <i class="fas fa-file-alt me-1"></i>
              {{ 'SHIPMENT_REQUEST.WAYBILLS' | translate }}
            </button>
            <button type="button" class="btn btn-sm"
              [ngClass]="viewMode === 'parcel' ? 'btn-primary' : 'btn-outline-primary'" (click)="toggleViewMode()"
              [title]="'SHIPMENT_REQUEST.VIEW_BY_PARCEL' | translate">
              <i class="fas fa-cube me-1"></i>
              {{ 'SHIPMENT_REQUEST.PARCELS' | translate }}
            </button>
          </div>

          <!-- Display Mode Toggle -->
          <div class="btn-group btn-group-sm" role="group">
            <button type="button" class="btn btn-sm"
              [ngClass]="displayMode === 'table' ? 'btn-secondary' : 'btn-outline-secondary'"
              (click)="toggleDisplayMode()" [title]="'SHIPMENT_REQUEST.TABLE_VIEW' | translate">
              <i class="fas fa-table"></i>
            </button>
            <button type="button" class="btn btn-sm"
              [ngClass]="displayMode === 'cards' ? 'btn-secondary' : 'btn-outline-secondary'"
              (click)="toggleDisplayMode()" [title]="'SHIPMENT_REQUEST.CARDS_VIEW' | translate">
              <i class="fas fa-th-large"></i>
            </button>
          </div> <!-- Items per page selector -->
          <div class="btn-group btn-group-sm pagination-selector" role="group">
            <button type="button" class="btn" [ngClass]="itemsPerPage === 5 ? 'btn-secondary' : 'btn-outline-secondary'"
              (click)="setItemsPerPage(5)" [title]="'5 ' + ('SHIPMENT_REQUEST.ITEMS_PER_PAGE' | translate)">
              5
            </button>
            <button type="button" class="btn"
              [ngClass]="itemsPerPage === 10 ? 'btn-secondary' : 'btn-outline-secondary'" (click)="setItemsPerPage(10)"
              [title]="'10 ' + ('SHIPMENT_REQUEST.ITEMS_PER_PAGE' | translate)">
              10
            </button>
            <button type="button" class="btn"
              [ngClass]="itemsPerPage === 25 ? 'btn-secondary' : 'btn-outline-secondary'" (click)="setItemsPerPage(25)"
              [title]="'25 ' + ('SHIPMENT_REQUEST.ITEMS_PER_PAGE' | translate)">
              25
            </button>
            <button type="button" class="btn"
              [ngClass]="itemsPerPage === 50 ? 'btn-secondary' : 'btn-outline-secondary'" (click)="setItemsPerPage(50)"
              [title]="'50 ' + ('SHIPMENT_REQUEST.ITEMS_PER_PAGE' | translate)">
              50
            </button>
            <button type="button" class="btn"
              [ngClass]="itemsPerPage === 100 ? 'btn-secondary' : 'btn-outline-secondary'"
              (click)="setItemsPerPage(100)" [title]="'100 ' + ('SHIPMENT_REQUEST.ITEMS_PER_PAGE' | translate)">
              100
            </button>
          </div>

          <!-- Counter Badge -->
          <div class="counter-display">
            <span class="badge bg-light text-muted">
              <i class="fas" [ngClass]="viewMode === 'waybill' ? 'fa-file-alt' : 'fa-cube'" [class.me-1]="true"></i>
              {{ viewMode === 'waybill' ? filteredWaybills.length : filteredParcels.length }}
            </span>
          </div>
        </div>
      </div>
    </div>


    <!-- Table Display Mode -->
    <div *ngIf="displayMode === 'table'" class="card-body p-0 results-table-body"
         [class.table-compact]="isCompactTable">
      <div class="table-container">
        <div class="table-responsive">
          <!-- Waybill Table View -->
          <table *ngIf="viewMode === 'waybill'" class="table table-hover mb-0">
            <thead class="table-light">
              <tr>
                <th class="sortable-header" (click)="sortBy('index')"
                  [title]="'SHIPMENT_REQUEST.SORT_BY_INDEX' | translate">
                  #
                  <i [class]="getSortIcon('index')"></i>
                </th>
                <th class="sortable-header" (click)="sortBy('waybillCode')"
                  [title]="'SHIPMENT_REQUEST.SORT_BY_WAYBILL_CODE' | translate">
                  {{ 'SHIPMENT_REQUEST.WAYBILL_CODE' | translate }}
                  <i [class]="getSortIcon('waybillCode')"></i>
                </th>
                <th class="sortable-header" (click)="sortBy('waybillDate')"
                  [title]="'SHIPMENT_REQUEST.SORT_BY_DATE_TIME' | translate">
                  {{ 'SHIPMENT_REQUEST.DATE_TIME' | translate }}
                  <i [class]="getSortIcon('waybillDate')"></i>
                </th>
                <th class="sortable-header" (click)="sortBy('companyName')"
                  [title]="'SHIPMENT_REQUEST.SORT_BY_COMPANY_NAME' | translate">
                  {{ 'SHIPMENT_REQUEST.COMPANY_NAME' | translate }}
                  <i [class]="getSortIcon('companyName')"></i>
                </th>
                <th class="sortable-header" (click)="sortBy('address')"
                  [title]="'SHIPMENT_REQUEST.SORT_BY_ADDRESS' | translate">
                  {{ 'SHIPMENT_REQUEST.ADDRESS' | translate }}
                  <i [class]="getSortIcon('address')"></i>
                </th>
                <th class="sortable-header" (click)="sortBy('city')"
                  [title]="'SHIPMENT_REQUEST.SORT_BY_CITY' | translate">
                  {{ 'SHIPMENT_REQUEST.CITY' | translate }}
                  <i [class]="getSortIcon('city')"></i>
                </th>
                <th class="sortable-header" (click)="sortBy('province')"
                  [title]="'SHIPMENT_REQUEST.SORT_BY_PROVINCE' | translate">
                  {{ 'SHIPMENT_REQUEST.PROVINCE' | translate }}
                  <i [class]="getSortIcon('province')"></i>
                </th>
                <th class="sortable-header" (click)="sortBy('parcelsCount')"
                  [title]="'SHIPMENT_REQUEST.SORT_BY_PARCELS_COUNT' | translate">
                  {{ 'SHIPMENT_REQUEST.PARCELS_COUNT' | translate }}
                  <i [class]="getSortIcon('parcelsCount')"></i>
                </th>
                <th class="sortable-header" (click)="sortBy('status')"
                  [title]="'SHIPMENT_REQUEST.SORT_BY_STATUS' | translate">
                  {{ 'SHIPMENT_REQUEST.STATUS' | translate }}
                  <i [class]="getSortIcon('status')"></i>
                </th>
                <th class="text-center" style="width: 60px;" title="{{ 'SHIPMENT_REQUEST.LABELS' | translate }}">
                  <i class="fas fa-tags"></i>
                </th>
                <th class="text-center" style="width: 60px;"
                  title="{{ 'SHIPMENT_REQUEST.WAYBILL_DOCUMENT' | translate }}">
                  <i class="fas fa-file-invoice"></i>
                </th>
                <th *ngIf="showBorderoSection" class="sortable-header text-center" style="width: 60px;" (click)="sortBy('bordero')">
                  Borderò
                  <i [class]="getSortIcon('bordero')"></i>
                </th>
                <th *ngIf="canDelete() || canUpdate()" class="text-center" style="width: 120px;">{{
                  'SHIPMENT_REQUEST.ACTIONS' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let waybill of paginatedWaybills; trackBy: trackWaybillById; let i = index"
                  [class.row-pending]="waybill.waybillStatus === 'PENDING'">
                <td class="text-muted">{{ (currentPage - 1) * itemsPerPage + i + 1 }}</td>
                <td class="fw-medium">{{ waybill.waybillCode }}</td>
                <td>{{ waybill.waybillDate | date:'dd/MM/yyyy' }}</td>
                <td>
                  <ng-container *ngIf="getDealerByCode(waybill.waybillDealerCode) as dealer; else noDealerInfo">
                    {{ dealer.dealerName }}
                  </ng-container>
                  <ng-template #noDealerInfo>
                    <span class="text-muted">-</span>
                  </ng-template>
                </td>
                <td>
                  <ng-container *ngIf="getDealerByCode(waybill.waybillDealerCode) as dealer; else noAddressInfo">
                    {{ dealer.dealerOperatingAddressStreet }} {{ dealer.dealerOperatingAddressNumber }}
                  </ng-container>
                  <ng-template #noAddressInfo>
                    <span class="text-muted">-</span>
                  </ng-template>
                </td>
                <td>
                  <ng-container *ngIf="getDealerByCode(waybill.waybillDealerCode) as dealer; else noCityInfo">
                    {{ dealer.dealerOperatingAddressCity }}
                  </ng-container>
                  <ng-template #noCityInfo>
                    <span class="text-muted">-</span>
                  </ng-template>
                </td>
                <td>
                  <ng-container *ngIf="getDealerByCode(waybill.waybillDealerCode) as dealer; else noProvinceInfo">
                    {{ dealer.dealerOperatingAddressProvince }}
                  </ng-container>
                  <ng-template #noProvinceInfo>
                    <span class="text-muted">-</span>
                  </ng-template>
                </td>
                <td>
                  <span class="parcel-count">{{ getParcelCountForWaybill(waybill.waybillCode) }}</span>
                </td>
                <td>
                  <div class="d-inline-flex align-items-center gap-2">
                    <span class="status-indicator" [ngClass]="{
                    'status-active': waybill.waybillStatus === 'ACTIVE',
                    'status-pending': waybill.waybillStatus === 'PENDING',
                    'status-cancelled': waybill.waybillStatus === 'CANCELLED',
                    'status-delivered': waybill.waybillStatus === 'DELIVERED'
                  }">
                      {{ waybill.waybillStatus }}
                    </span>
                    <div *ngIf="waybill.waybillStatus === 'PENDING'" class="pending-info-wrapper">
                      <button type="button" class="pending-info-btn"
                        (click)="togglePendingInfo(waybill.waybillId!, $event)"
                        title="Informazioni stato">
                        ?
                      </button>
                      <div class="pending-info-popup" *ngIf="pendingInfoWaybillId === waybill.waybillId">
                        <i class="fas fa-clock me-1"></i>
                        Bolla in attesa che il dealer inserito venga completato con le informazioni necessarie.
                      </div>
                    </div>
                  </div>
                </td>
                <td class="text-center">
                  <button type="button" class="download-btn download-labels"
                    (click)="downloadLabels(waybill.waybillId!)"
                    [disabled]="waybill.waybillStatus === 'PENDING'"
                    [title]="'SHIPMENT_REQUEST.DOWNLOAD_LABELS' | translate">
                    <i class="fas fa-tags"></i>
                  </button>
                </td>
                <td class="text-center">
                  <button type="button" class="download-btn download-document"
                    (click)="downloadWaybillDocument(waybill.waybillId!)"
                    [disabled]="waybill.waybillStatus === 'PENDING'"
                    [title]="'SHIPMENT_REQUEST.DOWNLOAD_WAYBILL' | translate">
                    <i class="fas fa-file-invoice"></i>
                  </button>
                </td>
                <td *ngIf="showBorderoSection" class="text-center">
                  <button type="button" class="download-btn download-bordero fw-bold"
                    [disabled]="!waybill.waybillLoadingList || stampingBordero.has(waybill.waybillLoadingList!)"
                    (click)="downloadBorderoForWaybill(waybill)"
                    [title]="'SHIPMENT_REQUEST.DOWNLOAD_BORDERO' | translate">
                    {{ waybill.waybillLoadingList || '-' }}
                  </button>
                </td>
                <td *ngIf="canDelete() || canUpdate()" class="text-center">
                  <div class="dropdown">
                    <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button"
                      [id]="'dropdownMenuButton' + waybill.waybillId"
                      [disabled]="!!waybill.waybillLoadingList"
                      [title]="waybill.waybillLoadingList ? ('Bolla già associata al borderò ' + waybill.waybillLoadingList) : ''"
                      [attr.aria-expanded]="isDropdownOpen('waybill_' + waybill.waybillId)"
                      (click)="toggleDropdown('waybill_' + waybill.waybillId, $event)">
                      <i class="bi bi-three-dots-vertical"></i>
                    </button>
                    <ul class="dropdown-menu" [class.show]="isDropdownOpen('waybill_' + waybill.waybillId)"
                      [attr.aria-labelledby]="'dropdownMenuButton' + waybill.waybillId">
                      <li *ngIf="canUpdate()"><a class="dropdown-item" href="javascript:void(0)"
                            [class.disabled]="!canEditWaybill(waybill.waybillDate || '')"
                            [style.opacity]="!canEditWaybill(waybill.waybillDate || '') ? '0.5' : '1'"
                            [style.cursor]="!canEditWaybill(waybill.waybillDate || '') ? 'not-allowed' : 'pointer'"
                            (click)="canEditWaybill(waybill.waybillDate || '') && editShipment(waybill.waybillId!); canEditWaybill(waybill.waybillDate || '') && showWarningMessage('Modifica bolla: ' + waybill.waybillCode); canEditWaybill(waybill.waybillDate || '') && scrollToTopSmooth(); closeAllDropdowns(); ">
                            <i class="fas fa-edit"></i> {{ 'SHIPMENT_REQUEST.EDIT' | translate }}
                        </a></li>
                      <li *ngIf="canDelete()"><a class="dropdown-item" href="javascript:void(0)"
                          (click)="deleteShipment(waybill.waybillId!); closeAllDropdowns()">
                          <i class="fas fa-trash"></i> {{ 'SHIPMENT_REQUEST.DELETE' | translate }}
                        </a></li>
                    </ul>
                  </div>
                </td>
              </tr> <!-- Messaggio quando non ci sono bolle -->
              <tr *ngIf="filteredWaybills.length === 0">
                <td colspan="13" class="text-center text-muted py-4">
                  <i class="fas fa-inbox fa-2x mb-2"></i>
                  <div>{{ 'SHIPMENT_REQUEST.NO_WAYBILLS_YET' | translate }}</div>
                </td>
              </tr>
            </tbody>
          </table> <!-- Parcel Table View -->
          <table *ngIf="viewMode === 'parcel'" class="table table-hover mb-0">
            <thead class="table-light">
              <tr>
                <th class="sortable-header" (click)="sortBy('index')"
                  [title]="'SHIPMENT_REQUEST.SORT_BY_INDEX' | translate">
                  #
                  <i [class]="getSortIcon('index')"></i>
                </th>
                <th class="sortable-header" (click)="sortBy('parcelCode')"
                  [title]="'SHIPMENT_REQUEST.SORT_BY_PARCEL_CODE' | translate">
                  {{ 'SHIPMENT_REQUEST.PARCEL_CODE' | translate }}
                  <i [class]="getSortIcon('parcelCode')"></i>
                </th>
                <th class="sortable-header" (click)="sortBy('parcelDate')"
                  [title]="'SHIPMENT_REQUEST.SORT_BY_DATE_TIME' | translate">
                  {{ 'SHIPMENT_REQUEST.DATE_TIME' | translate }}
                  <i [class]="getSortIcon('parcelDate')"></i>
                </th>
                <th class="sortable-header" (click)="sortBy('waybillCode')"
                  [title]="'SHIPMENT_REQUEST.SORT_BY_WAYBILL_CODE' | translate">
                  {{ 'SHIPMENT_REQUEST.WAYBILL_CODE' | translate }}
                  <i [class]="getSortIcon('waybillCode')"></i>
                </th>
                <th class="sortable-header" (click)="sortBy('companyName')"
                  [title]="'SHIPMENT_REQUEST.SORT_BY_COMPANY_NAME' | translate">
                  {{ 'SHIPMENT_REQUEST.COMPANY_NAME' | translate }}
                  <i [class]="getSortIcon('companyName')"></i>
                </th>
                <th class="sortable-header" (click)="sortBy('address')"
                  [title]="'SHIPMENT_REQUEST.SORT_BY_ADDRESS' | translate">
                  {{ 'SHIPMENT_REQUEST.ADDRESS' | translate }}
                  <i [class]="getSortIcon('address')"></i>
                </th>
                <th class="sortable-header" (click)="sortBy('city')"
                  [title]="'SHIPMENT_REQUEST.SORT_BY_CITY' | translate">
                  {{ 'SHIPMENT_REQUEST.CITY' | translate }}
                  <i [class]="getSortIcon('city')"></i>
                </th>
                <th class="sortable-header" (click)="sortBy('province')"
                  [title]="'SHIPMENT_REQUEST.SORT_BY_PROVINCE' | translate">
                  {{ 'SHIPMENT_REQUEST.PROVINCE' | translate }}
                  <i [class]="getSortIcon('province')"></i>
                </th>
                <th class="sortable-header" (click)="sortBy('weight')"
                  [title]="'SHIPMENT_REQUEST.SORT_BY_WEIGHT' | translate">
                  {{ 'SHIPMENT_REQUEST.WEIGHT' | translate }}
                  <i [class]="getSortIcon('weight')"></i>
                </th>
                <th class="sortable-header" (click)="sortBy('volume')"
                  [title]="'SHIPMENT_REQUEST.SORT_BY_VOLUME' | translate">
                  {{ 'SHIPMENT_REQUEST.VOLUME' | translate }}
                  <i [class]="getSortIcon('volume')"></i>
                </th>
                <th class="sortable-header" (click)="sortBy('insuredValue')"
                  [title]="'SHIPMENT_REQUEST.SORT_BY_INSURED_VALUE' | translate">
                  {{ 'SHIPMENT_REQUEST.INSURED_VALUE' | translate }}
                  <i [class]="getSortIcon('insuredValue')"></i>
                </th>
                <th *ngIf="showBorderoSection" class="sortable-header text-center" style="width: 60px;" (click)="sortBy('bordero')">
                  Borderò
                  <i [class]="getSortIcon('bordero')"></i>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let parcel of paginatedParcels; trackBy: trackParcelById; let i = index">
                <td>{{ (currentPage - 1) * itemsPerPage + i + 1 }}</td>
                <td class="fw-medium">{{ parcel.parcelCode || '-' }}</td>
                <td>{{ parcel.parcelDate | date:'dd/MM/yyyy' }}</td>
                <td>{{ parcel.waybillCode }}</td>
                <td>
                  <ng-container *ngIf="getDealerByCode(parcel.parcelDealerCode) as dealer; else noCompanyInfo">
                    {{ dealer.dealerName }}
                  </ng-container>
                  <ng-template #noCompanyInfo>
                    <span class="text-muted">{{ parcel.dealerName || '-' }}</span>
                  </ng-template>
                </td>
                <td>
                  <ng-container *ngIf="getDealerByCode(parcel.parcelDealerCode) as dealer; else noAddressParcelInfo">
                    {{ dealer.dealerOperatingAddressStreet }} {{ dealer.dealerOperatingAddressNumber }}
                  </ng-container>
                  <ng-template #noAddressParcelInfo>
                    <span class="text-muted">-</span>
                  </ng-template>
                </td>
                <td>
                  <ng-container *ngIf="getDealerByCode(parcel.parcelDealerCode) as dealer; else noCityParcelInfo">
                    {{ dealer.dealerOperatingAddressCity }}
                  </ng-container>
                  <ng-template #noCityParcelInfo>
                    <span class="text-muted">-</span>
                  </ng-template>
                </td>
                <td>
                  <ng-container *ngIf="getDealerByCode(parcel.parcelDealerCode) as dealer; else noProvinceParcelInfo">
                    {{ dealer.dealerOperatingAddressProvince }}
                  </ng-container>
                  <ng-template #noProvinceParcelInfo>
                    <span class="text-muted">-</span>
                  </ng-template>
                </td>
                <td>{{ parcel.parcelWeight | number:'1.1-2' }} kg</td>
                <td>{{ parcel.parcelVolume | number:'1.4-4' }} m³</td>
                <td>{{ parcel.parcelInsuredValue != null ? (parcel.parcelInsuredValue | number:'1.2-2') : '0.00' }} €
                </td>
                <td *ngIf="showBorderoSection" class="text-center">
                  <button type="button" class="download-btn download-bordero fw-bold"
                    [disabled]="!parcel.parcelLoadingList || stampingBordero.has(parcel.parcelLoadingList!)"
                    (click)="downloadBorderoForParcel(parcel)"
                    [title]="'SHIPMENT_REQUEST.DOWNLOAD_BORDERO' | translate">
                    {{ parcel.parcelLoadingList || '-' }}
                  </button>
                </td>
              </tr> <!-- Messaggio quando non ci sono colli -->
              <tr *ngIf="filteredParcels.length === 0">
                <td colspan="12" class="text-center text-muted py-4">
                  <i class="fas fa-inbox fa-2x mb-2"></i>
                  <div>{{ 'SHIPMENT_REQUEST.NO_PARCELS_YET' | translate }}</div>
                </td>
              </tr>
            </tbody>
          </table>

        </div>
      </div> <!-- Pagination Controls for Table Mode -->
      <div class="pagination-container">
        <div class="pagination-controls">
          <button class="pagination-btn" (click)="onPageChange(currentPage - 1)" [disabled]="currentPage === 1"
            [attr.aria-label]="'PAGINATION.PREVIOUS' | translate" [title]="'PAGINATION.PREVIOUS' | translate">
            <i class="fas fa-chevron-left"></i>
          </button>

          <div class="page-numbers">
            <button *ngFor="let page of getPageNumbers(); trackBy: trackByPageNumber" class="pagination-number"
              [class.active]="page === currentPage" (click)="onPageChange(page)" [attr.aria-label]="'Pagina ' + page"
              [title]="'Vai alla pagina ' + page">
              {{ page }}
            </button>
          </div>

          <span class="pagination-info">
            {{ rangeStart }} - {{ rangeEnd }} {{ 'PAGINATION.OF' | translate }} {{ totalItems }}
          </span>

          <button class="pagination-btn" (click)="onPageChange(currentPage + 1)"
            [disabled]="currentPage === getTotalPages()" [attr.aria-label]="'PAGINATION.NEXT' | translate"
            [title]="'PAGINATION.NEXT' | translate">
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Cards Display Mode -->
    <div *ngIf="displayMode === 'cards'" class="card-body"><!-- Waybill Cards View -->
      <div *ngIf="viewMode === 'waybill'" class="row">
        <div *ngFor="let waybill of paginatedWaybills; trackBy: trackWaybillById; let i = index" class="col-md-6 col-lg-4 mb-3">
          <div class="card h-100 shadow-sm">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h6 class="mb-0">
                <i class="fas fa-file-alt me-2"></i>
                {{ waybill.waybillCode }}
              </h6>
              <div class="dropdown">
                <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button"
                  [id]="'dropdownMenuButtonCard' + waybill.waybillId"
                  [attr.aria-expanded]="isDropdownOpen('waybill_card_' + waybill.waybillId)"
                  (click)="toggleDropdown('waybill_card_' + waybill.waybillId, $event)">
                  <i class="bi bi-three-dots-vertical"></i>
                </button>
                <ul class="dropdown-menu" [class.show]="isDropdownOpen('waybill_card_' + waybill.waybillId)"
                  [attr.aria-labelledby]="'dropdownMenuButtonCard' + waybill.waybillId">
                  <li><a class="dropdown-item" href="javascript:void(0)"
                      [class.disabled]="!canEditWaybill(waybill.waybillDate || '')"
                      [style.opacity]="!canEditWaybill(waybill.waybillDate || '') ? '0.5' : '1'"
                      [style.cursor]="!canEditWaybill(waybill.waybillDate || '') ? 'not-allowed' : 'pointer'"
                      (click)="canEditWaybill(waybill.waybillDate || '') && editShipment(waybill.waybillId!); closeAllDropdowns()">
                      <i class="fas fa-edit"></i> {{ 'SHIPMENT_REQUEST.EDIT' | translate }}
                    </a></li>
                  <li><a class="dropdown-item" href="javascript:void(0)"
                      (click)="deleteShipment(waybill.waybillId!); closeAllDropdowns()">
                      <i class="fas fa-trash"></i> {{ 'SHIPMENT_REQUEST.DELETE' | translate }}
                    </a></li>
                </ul>
              </div>
            </div>
            <div class="card-body">
              <p class="card-text">
                <strong>{{ 'SHIPMENT_REQUEST.DATE_TIME' | translate }}:</strong><br>
                {{ waybill.waybillDate | date:'dd/MM/yyyy' }}
              </p>
              <p class="card-text">
                <strong>{{ 'SHIPMENT_REQUEST.DESTINATION' | translate }}:</strong><br>
                <ng-container *ngIf="getDealerByCode(waybill.waybillDealerCode) as dealer; else noDealerInfoCard">
                  {{ dealer.dealerName }}<br>
                  <small class="text-muted">{{ dealer.dealerOperatingAddressCity }}, {{
                    dealer.dealerOperatingAddressProvince }}</small>
                </ng-container>
                <ng-template #noDealerInfoCard>
                  <span class="text-muted">Dealer non trovato</span>
                </ng-template>
              </p>
              <div class="d-flex justify-content-between align-items-center mb-3">
                <span class="parcel-count">{{ getParcelCountForWaybill(waybill.waybillCode) }} {{
                  'SHIPMENT_REQUEST.PARCELS' | translate }}</span>
                <span class="status-indicator" [ngClass]="{
                  'status-active': waybill.waybillStatus === 'ACTIVE',
                  'status-pending': waybill.waybillStatus === 'PENDING',
                  'status-cancelled': waybill.waybillStatus === 'CANCELLED',
                  'status-delivered': waybill.waybillStatus === 'DELIVERED'
                }">
                  {{ waybill.waybillStatus }}
                </span>
              </div>

              <!-- Download buttons for waybill card -->
              <div class="d-flex gap-2 mb-2">
                <button type="button" class="btn btn-sm btn-outline-primary flex-fill"
                  (click)="downloadLabels(waybill.waybillId!)" [title]="'SHIPMENT_REQUEST.DOWNLOAD_LABELS' | translate">
                  <i class="fas fa-tags me-1"></i>
                  {{ 'SHIPMENT_REQUEST.LABELS' | translate }}
                </button>
                <button type="button" class="btn btn-sm btn-outline-secondary flex-fill"
                  (click)="downloadWaybillDocument(waybill.waybillId!)"
                  [title]="'SHIPMENT_REQUEST.DOWNLOAD_WAYBILL' | translate">
                  <i class="fas fa-file-invoice me-1"></i>
                  {{ 'SHIPMENT_REQUEST.WAYBILL_DOCUMENT' | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- Messaggio quando non ci sono bolle -->
        <div *ngIf="filteredWaybills.length === 0" class="col-12">
          <div class="text-center text-muted py-5">
            <i class="fas fa-inbox fa-3x mb-3"></i>
            <h5>{{ 'SHIPMENT_REQUEST.NO_WAYBILLS_YET' | translate }}</h5>
          </div>
        </div>
      </div> <!-- Parcel Cards View -->
      <div *ngIf="viewMode === 'parcel'" class="row">
        <div *ngFor="let parcel of paginatedParcels; trackBy: trackParcelById; let i = index" class="col-md-6 col-lg-4 mb-3">
          <div class="card h-100 shadow-sm">
            <div class="card-header">
              <h6 class="mb-0">
                <i class="fas fa-cube me-2"></i>
                {{ parcel.parcelCode || ('SHIPMENT_REQUEST.PARCEL' | translate) + ' ' + (i + 1) }}
              </h6>
            </div>
            <div class="card-body">
              <p class="card-text">
                <strong>{{ 'SHIPMENT_REQUEST.WAYBILL_CODE' | translate }}:</strong><br>
                {{ parcel.waybillCode }}
              </p>
              <p class="card-text">
                <strong>{{ 'SHIPMENT_REQUEST.DATE_TIME' | translate }}:</strong><br>
                {{ parcel.parcelDate | date:'dd/MM/yyyy' }}
              </p>
              <p class="card-text">
                <strong>{{ 'SHIPMENT_REQUEST.DESTINATION' | translate }}:</strong><br>
                {{ parcel.dealerName }}
              </p>
              <p class="card-text" *ngIf="parcel.parcelDescription">
                <strong>{{ 'SHIPMENT_REQUEST.PARCEL_DESCRIPTION' | translate }}:</strong><br>
                {{ parcel.parcelDescription }}
              </p>
              <div class="row text-center">
                <div class="col-4">
                  <small class="text-muted">{{ 'SHIPMENT_REQUEST.WEIGHT' | translate }}</small><br>
                  <span class="fw-bold">{{ parcel.parcelWeight | number:'1.1-2' }} kg</span>
                </div>
                <div class="col-4">
                  <small class="text-muted">{{ 'SHIPMENT_REQUEST.VOLUME' | translate }}</small><br>
                  <span class="fw-bold">{{ parcel.parcelVolume | number:'1.4-4' }} m³</span>
                </div>
                <div class="col-4">
                  <small class="text-muted">{{ 'SHIPMENT_REQUEST.INSURED_VALUE' | translate }}</small><br>
                  <span class="fw-bold">{{ (parcel.parcelInsuredValue != null ? parcel.parcelInsuredValue : 0) |
                    number:'1.2-2' }} €</span>
                </div>
              </div>
            </div>
          </div>
        </div><!-- Messaggio quando non ci sono colli -->
        <div *ngIf="filteredParcels.length === 0" class="col-12">
          <div class="text-center text-muted py-5">
            <i class="fas fa-inbox fa-3x mb-3"></i>
            <h5>{{ 'SHIPMENT_REQUEST.NO_PARCELS_YET' | translate }}</h5>
          </div>
        </div>
      </div> <!-- Pagination Controls for Cards Mode -->
      <div class="pagination-container">
        <div class="pagination-controls">
          <button class="pagination-btn" (click)="onPageChange(currentPage - 1)" [disabled]="currentPage === 1"
            [attr.aria-label]="'PAGINATION.PREVIOUS' | translate" [title]="'PAGINATION.PREVIOUS' | translate">
            <i class="fas fa-chevron-left"></i>
          </button>

          <div class="page-numbers">
            <button *ngFor="let page of getPageNumbers(); trackBy: trackByPageNumber" class="pagination-number"
              [class.active]="page === currentPage" (click)="onPageChange(page)" [attr.aria-label]="'Pagina ' + page"
              [title]="'Vai alla pagina ' + page">
              {{ page }}
            </button>
          </div>

          <span class="pagination-info">
            {{ rangeStart }} - {{ rangeEnd }} {{ 'PAGINATION.OF' | translate }} {{ totalItems }}
          </span>

          <button class="pagination-btn" (click)="onPageChange(currentPage + 1)"
            [disabled]="currentPage === getTotalPages()" [attr.aria-label]="'PAGINATION.NEXT' | translate"
            [title]="'PAGINATION.NEXT' | translate">
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>
    <!-- </div> -->
  </div>

  <!-- Confirmation Dialog -->
  <div *ngIf="showConfirmDialog" class="confirmation-backdrop" (click)="closeConfirmationDialog()">
    <div class="confirmation-dialog" (click)="$event.stopPropagation()">
      <div class="dialog-header">
        <h3>{{ confirmationTitle }}</h3>
      </div>

      <div class="dialog-body">
        <p [innerHTML]="confirmationMessage"></p>
      </div>

      <div class="dialog-footer">
        <button type="button" class="btn btn-secondary" (click)="closeConfirmationDialog()">
          {{ 'SHIPMENT_REQUEST.CANCEL' | translate }}
        </button>
        <button type="button" class="btn btn-primary" (click)="confirmAction()">
          {{ 'SHIPMENT_REQUEST.CONFIRM' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- Popup gestione dealer (create / edit) -->
  <app-dealer-management-popup
    [visible]="showDealerManagementPopup"
    [mode]="dealerManagementMode"
    [dealer]="dealerManagementInitial"
    [defaultClientCode]="shipmentForm.get('waybill.waybillClientCode')?.value || ''"
    [defaultBrandCode]="shipmentForm.get('waybill.waybillBrandCode')?.value || ''"
    [clientsBrands]="clientsBrands"
    [fieldSettings]="currentFieldSettings"
    (closed)="closeDealerManagementPopup()"
    (saved)="onDealerManagementSaved($event)">
  </app-dealer-management-popup>

  <!-- Popup overlay per inserimento dealer -->
  <div class="custom-popup-overlay" *ngIf="showDealerInsertPopup" (click)="closeDealerInsertPopup()">
    <div class="custom-popup-content dealer-popup" (click)="$event.stopPropagation()">
      <div class="custom-popup-header">
        <h5><i class="fas me-2" [ngClass]="isEditingDealer ? 'fa-edit' : 'fa-plus'"></i>{{ getDealerPopupTitle() }}</h5>
        <button class="custom-popup-close" aria-label="Chiudi" (click)="closeDealerInsertPopup()">&times;</button>
      </div>

      <div class="custom-popup-body">
        <form [formGroup]="dealerForm" (ngSubmit)="onDealerFormSubmit()" *ngIf="dealerForm"> <!-- Dati Principali -->
          <div class="form-section mb-4">
            <h6 class="section-title"><i class="fas fa-info-circle me-2"></i>Dati Principali</h6>
            <div class="row">
              <div class="col-md-4">
                <div class="mb-3">
                  <label for="dealerCodeField" class="form-label">Codice Dealer</label>
                  <div class="input-group">
                    <span class="input-group-text field-icon"><i class="fas fa-hashtag"></i></span>
                    <input type="text" class="form-control" id="dealerCodeField" formControlName="dealerCode"
                      placeholder="Codice identificativo del dealer" [disabled]="true">
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="mb-3">
                  <label for="dealerClientCodeField" class="form-label">Codice Cliente</label>
                  <div class="input-group">
                    <span class="input-group-text field-icon"><i class="fas fa-user"></i></span>
                    <input type="text" class="form-control" id="dealerClientCodeField"
                      formControlName="dealerClientCode" placeholder="Codice cliente del dealer" [disabled]="true">
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="mb-3">
                  <label for="dealerBrandCodeField" class="form-label">Codice Brand</label>
                  <div class="input-group">
                    <span class="input-group-text field-icon"><i class="fas fa-tag"></i></span>
                    <input type="text" class="form-control" id="dealerBrandCodeField" formControlName="dealerBrandCode"
                      placeholder="Codice brand del dealer" [disabled]="true">
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <label for="dealerName" class="form-label">Ragione Sociale *</label>
                  <div class="input-group">
                    <span class="input-group-text field-icon"><i class="fas fa-user-tie"></i></span>
                    <input type="text" class="form-control" id="dealerName" formControlName="name"
                      placeholder="Nome dell'azienda o dealer"
                      [class.is-invalid]="dealerForm.get('name')?.invalid && dealerForm.get('name')?.touched">
                  </div>
                  <div class="invalid-feedback"
                    *ngIf="dealerForm.get('name')?.hasError('required') && dealerForm.get('name')?.touched">
                    Il nome è obbligatorio
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <label for="vatNumber" class="form-label">Partita IVA</label>
                  <div class="input-group">
                    <span class="input-group-text field-icon"><i class="fas fa-receipt"></i></span>
                    <input type="text" class="form-control" id="vatNumber" formControlName="vatNumber"
                      placeholder="es. IT12345678901">
                  </div>
                </div>
              </div>
            </div>
          </div><!-- Indirizzo Legale -->
          <div class="form-section mb-4" formGroupName="legalAddress">
            <h6 class="section-title">
              <i class="fas fa-building me-2"></i>Indirizzo Legale
              <button type="button" class="btn btn-sm btn-outline-secondary ms-2" (click)="copyOperatingToLegal()"
                title="Copia da indirizzo operativo">
                <i class="fas fa-copy"></i>
                <i class="fas fa-arrow-up ms-1"></i>
              </button>
            </h6>
            <div class="row">
              <div class="col-md-8">
                <div class="mb-3">
                  <label for="legalStreet" class="form-label">Via *</label>
                  <div class="input-group">
                    <span class="input-group-text field-icon"><i class="fas fa-road"></i></span>
                    <input type="text" class="form-control" id="legalStreet" formControlName="street"
                      placeholder="es. Via Roma"
                      [class.is-invalid]="dealerForm.get('legalAddress.street')?.invalid && dealerForm.get('legalAddress.street')?.touched">
                  </div>
                  <div class="invalid-feedback"
                    *ngIf="dealerForm.get('legalAddress.street')?.hasError('required') && dealerForm.get('legalAddress.street')?.touched">
                    La via è obbligatoria
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="mb-3">
                  <label for="legalNumber" class="form-label">Numero</label>
                  <div class="input-group">
                    <span class="input-group-text field-icon"><i class="fas fa-sort-numeric-up"></i></span>
                    <input type="text" class="form-control" id="legalNumber" formControlName="number"
                      placeholder="es. 123">
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <div class="mb-3">
                  <label for="legalZip" class="form-label">CAP *</label>
                  <div class="input-group">
                    <span class="input-group-text field-icon"><i class="fas fa-mail-bulk"></i></span>
                    <input type="text" class="form-control" id="legalZip" formControlName="zip" placeholder="es. 00100"
                      [class.is-invalid]="dealerForm.get('legalAddress.zip')?.invalid && dealerForm.get('legalAddress.zip')?.touched">
                  </div>
                  <div class="invalid-feedback"
                    *ngIf="dealerForm.get('legalAddress.zip')?.hasError('required') && dealerForm.get('legalAddress.zip')?.touched">
                    Il CAP è obbligatorio
                  </div>
                </div>
              </div>
              <div class="col-md-5">
                <div class="mb-3">
                  <label for="legalCity" class="form-label">Città *</label>
                  <div class="input-group">
                    <span class="input-group-text field-icon"><i class="fas fa-city"></i></span>
                    <input type="text" class="form-control" id="legalCity" formControlName="city" placeholder="es. Roma"
                      [class.is-invalid]="dealerForm.get('legalAddress.city')?.invalid && dealerForm.get('legalAddress.city')?.touched">
                  </div>
                  <div class="invalid-feedback"
                    *ngIf="dealerForm.get('legalAddress.city')?.hasError('required') && dealerForm.get('legalAddress.city')?.touched">
                    La città è obbligatoria
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="mb-3">
                  <label for="legalProvince" class="form-label">Provincia *</label>
                  <div class="input-group">
                    <span class="input-group-text field-icon"><i class="fas fa-map"></i></span>
                    <input type="text" class="form-control" id="legalProvince" formControlName="province"
                      placeholder="es. RM"
                      [class.is-invalid]="dealerForm.get('legalAddress.province')?.invalid && dealerForm.get('legalAddress.province')?.touched">
                  </div>
                  <div class="invalid-feedback"
                    *ngIf="dealerForm.get('legalAddress.province')?.hasError('required') && dealerForm.get('legalAddress.province')?.touched">
                    La provincia è obbligatoria
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="legalCountry" class="form-label">Nazione *</label>
                  <div class="input-group">
                    <span class="input-group-text field-icon"><i class="fas fa-flag"></i></span>
                    <select class="form-select" id="legalCountry" formControlName="country"
                      [class.is-invalid]="dealerForm.get('legalAddress.country')?.invalid && dealerForm.get('legalAddress.country')?.touched">
                      <option value="IT" selected>Italia</option>
                      <option value="SM">San Marino</option>
                      <option value="VA">Città del Vaticano</option>
                    </select>
                  </div>
                  <div class="invalid-feedback"
                    *ngIf="dealerForm.get('legalAddress.country')?.hasError('required') && dealerForm.get('legalAddress.country')?.touched">
                    La nazione è obbligatoria
                  </div>
                </div>
              </div>
            </div>
          </div><!-- Indirizzo Operativo -->
          <div class="form-section mb-4" formGroupName="operatingAddress">
            <h6 class="section-title">
              <i class="fas fa-map-marker-alt me-2"></i>Indirizzo Operativo
              <button type="button" class="btn btn-sm btn-outline-secondary ms-2" (click)="copyLegalToOperating()"
                title="Copia a indirizzo legale">
                <i class="fas fa-copy"></i>
                <i class="fas fa-arrow-down ms-1"></i>
              </button>
            </h6>
            <div class="row">
              <div class="col-md-8">
                <div class="mb-3">
                  <label for="operatingStreet" class="form-label">Via *</label>
                  <div class="input-group">
                    <span class="input-group-text field-icon"><i class="fas fa-road"></i></span>
                    <input type="text" class="form-control" id="operatingStreet" formControlName="street"
                      placeholder="es. Via Roma"
                      [class.is-invalid]="dealerForm.get('operatingAddress.street')?.invalid && dealerForm.get('operatingAddress.street')?.touched">
                  </div>
                  <div class="invalid-feedback"
                    *ngIf="dealerForm.get('operatingAddress.street')?.hasError('required') && dealerForm.get('operatingAddress.street')?.touched">
                    La via è obbligatoria
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="mb-3">
                  <label for="operatingNumber" class="form-label">Numero</label>
                  <div class="input-group">
                    <span class="input-group-text field-icon"><i class="fas fa-sort-numeric-up"></i></span>
                    <input type="text" class="form-control" id="operatingNumber" formControlName="number"
                      placeholder="es. 123">
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <div class="mb-3">
                  <label for="operatingZip" class="form-label">CAP *</label>
                  <div class="input-group">
                    <span class="input-group-text field-icon"><i class="fas fa-mail-bulk"></i></span>
                    <input type="text" class="form-control" id="operatingZip" formControlName="zip"
                      placeholder="es. 00100"
                      [class.is-invalid]="dealerForm.get('operatingAddress.zip')?.invalid && dealerForm.get('operatingAddress.zip')?.touched">
                  </div>
                  <div class="invalid-feedback"
                    *ngIf="dealerForm.get('operatingAddress.zip')?.hasError('required') && dealerForm.get('operatingAddress.zip')?.touched">
                    Il CAP è obbligatorio
                  </div>
                </div>
              </div>
              <div class="col-md-5">
                <div class="mb-3">
                  <label for="operatingCity" class="form-label">Città *</label>
                  <div class="input-group">
                    <span class="input-group-text field-icon"><i class="fas fa-city"></i></span>
                    <input type="text" class="form-control" id="operatingCity" formControlName="city"
                      placeholder="es. Roma"
                      [class.is-invalid]="dealerForm.get('operatingAddress.city')?.invalid && dealerForm.get('operatingAddress.city')?.touched">
                  </div>
                  <div class="invalid-feedback"
                    *ngIf="dealerForm.get('operatingAddress.city')?.hasError('required') && dealerForm.get('operatingAddress.city')?.touched">
                    La città è obbligatoria
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="mb-3">
                  <label for="operatingProvince" class="form-label">Provincia *</label>
                  <div class="input-group">
                    <span class="input-group-text field-icon"><i class="fas fa-map"></i></span>
                    <input type="text" class="form-control" id="operatingProvince" formControlName="province"
                      placeholder="es. RM"
                      [class.is-invalid]="dealerForm.get('operatingAddress.province')?.invalid && dealerForm.get('operatingAddress.province')?.touched">
                  </div>
                  <div class="invalid-feedback"
                    *ngIf="dealerForm.get('operatingAddress.province')?.hasError('required') && dealerForm.get('operatingAddress.province')?.touched">
                    La provincia è obbligatoria
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="operatingCountry" class="form-label">Nazione *</label>
                  <div class="input-group">
                    <span class="input-group-text field-icon"><i class="fas fa-flag"></i></span>
                    <select class="form-select" id="operatingCountry" formControlName="country"
                      [class.is-invalid]="dealerForm.get('operatingAddress.country')?.invalid && dealerForm.get('operatingAddress.country')?.touched">
                      <option value="IT" selected>Italia</option>
                      <option value="SM">San Marino</option>
                      <option value="VA">Città del Vaticano</option>
                    </select>
                  </div>
                  <div class="invalid-feedback"
                    *ngIf="dealerForm.get('operatingAddress.country')?.hasError('required') && dealerForm.get('operatingAddress.country')?.touched">
                    La nazione è obbligatoria
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="custom-popup-footer">
        <button type="button" class="btn btn-secondary" (click)="closeDealerInsertPopup()">
          <i class="fas fa-times me-1"></i>Annulla
        </button>
        <button type="button" class="btn btn-primary" (click)="onDealerFormSubmit()"
          [disabled]="!dealerForm || dealerForm.invalid">
          <i class="fas fa-save me-1"></i>Salva e Seleziona
        </button>
      </div>
    </div>
  </div>

  <!-- Popup overlay per inserimento distributivo -->
  <div class="custom-popup-overlay" *ngIf="showDistributiveInsertPopup" (click)="closeDistributiveInsertPopup()">
    <div class="custom-popup-content distributive-popup" (click)="$event.stopPropagation()">
      <div class="custom-popup-header">
        <h5><i class="fas fa-th me-2"></i>{{ 'SHIPMENT_REQUEST.DISTRIBUTIVE_INSERT_TITLE' | translate }}</h5>
        <button class="custom-popup-close" aria-label="Chiudi" (click)="closeDistributiveInsertPopup()">&times;</button>
      </div>
      
      <div class="custom-popup-body">
        <p class="text-muted mb-4">{{ 'SHIPMENT_REQUEST.DISTRIBUTIVE_INSERT_SUBTITLE' | translate }}</p>
        
        <form [formGroup]="distributiveForm!" (ngSubmit)="processDistributiveInsertion()" *ngIf="distributiveForm">
          <div class="row">
            <!-- Numero di Colli -->
            <div class="col-12 mb-3">
              <label for="parcelCount" class="form-label">
                {{ 'SHIPMENT_REQUEST.DISTRIBUTIVE_PARCEL_COUNT' | translate }}<span *ngIf="isFieldRequired('parcelCount')" class="text-danger ms-1">*</span>
              </label>
              <div class="position-relative">
                <input 
                  type="number" 
                  id="parcelCount" 
                  class="form-control ps-5"
                  formControlName="parcelCount"
                  [class.is-invalid]="distributiveForm.get('parcelCount')?.invalid && distributiveForm.get('parcelCount')?.touched"
                  [placeholder]="getFieldPlaceholder('parcelCount', 'SHIPMENT_REQUEST.DISTRIBUTIVE_PARCEL_COUNT_PLACEHOLDER' | translate)"
                  min="1"
                  max="99">
                <i class="fas fa-hashtag position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
              </div>
              <div class="invalid-feedback" *ngIf="distributiveForm.get('parcelCount')?.invalid && distributiveForm.get('parcelCount')?.touched">
                <span *ngIf="distributiveForm.get('parcelCount')?.errors?.['required']">Il numero di colli è obbligatorio</span>
                <span *ngIf="distributiveForm.get('parcelCount')?.errors?.['min']">Il numero minimo di colli è 1</span>
                <span *ngIf="distributiveForm.get('parcelCount')?.errors?.['max']">Il numero massimo di colli è 99</span>
              </div>
            </div>
            
            <!-- Peso Totale -->
            <div class="col-md-6 mb-3">
              <label for="totalWeight" class="form-label">
                {{ 'SHIPMENT_REQUEST.DISTRIBUTIVE_TOTAL_WEIGHT' | translate }} (kg)<span *ngIf="isFieldRequired('totalWeight')" class="text-danger ms-1">*</span>
              </label>
              <div class="position-relative">
                <input 
                  type="number" 
                  id="totalWeight" 
                  class="form-control ps-5"
                  formControlName="totalWeight"
                  [class.is-invalid]="distributiveForm.get('totalWeight')?.invalid && distributiveForm.get('totalWeight')?.touched"
                  [placeholder]="getFieldPlaceholder('totalWeight', 'SHIPMENT_REQUEST.DISTRIBUTIVE_TOTAL_WEIGHT_PLACEHOLDER' | translate)"
                  step="0.001"
                  min="0.001"
                  max="99999.999">
                <i class="fas fa-weight-hanging position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
              </div>
              <div class="invalid-feedback" *ngIf="distributiveForm.get('totalWeight')?.invalid && distributiveForm.get('totalWeight')?.touched">
                <span *ngIf="distributiveForm.get('totalWeight')?.errors?.['required']">Il peso totale è obbligatorio</span>
                <span *ngIf="distributiveForm.get('totalWeight')?.errors?.['minWeightVolume']">Il peso minimo è 0.001 kg</span>
                <span *ngIf="distributiveForm.get('totalWeight')?.errors?.['maxValue']">Il peso massimo è 99999.999 kg</span>
                <span *ngIf="distributiveForm.get('totalWeight')?.errors?.['maxDecimals']">Massimo 3 decimali consentiti</span>
                <span *ngIf="distributiveForm.get('totalWeight')?.errors?.['invalidNumber']">Inserisci un numero valido</span>
              </div>
            </div>
            
            <!-- Volume Totale -->
            <div class="col-md-6 mb-3">
              <label for="totalVolume" class="form-label">
                {{ 'SHIPMENT_REQUEST.DISTRIBUTIVE_TOTAL_VOLUME' | translate }} (m³)<span *ngIf="isFieldRequired('totalVolume')" class="text-danger ms-1">*</span>
              </label>
              <div class="position-relative">
                <input 
                  type="number" 
                  id="totalVolume" 
                  class="form-control ps-5"
                  formControlName="totalVolume"
                  [class.is-invalid]="distributiveForm.get('totalVolume')?.invalid && distributiveForm.get('totalVolume')?.touched"
                  [placeholder]="getFieldPlaceholder('totalVolume', 'SHIPMENT_REQUEST.DISTRIBUTIVE_TOTAL_VOLUME_PLACEHOLDER' | translate)"
                  step="0.0001"
                  min="0.0001"
                  max="99999.9999">
                <i class="fas fa-expand-arrows-alt position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
              </div>
              <div class="invalid-feedback" *ngIf="distributiveForm.get('totalVolume')?.invalid && distributiveForm.get('totalVolume')?.touched">
                <span *ngIf="distributiveForm.get('totalVolume')?.errors?.['required']">Il volume totale è obbligatorio</span>
                <span *ngIf="distributiveForm.get('totalVolume')?.errors?.['minWeightVolume']">Il volume minimo è 0.0001 m³</span>
                <span *ngIf="distributiveForm.get('totalVolume')?.errors?.['maxValue']">Il volume massimo è 99999.9999 m³</span>
                <span *ngIf="distributiveForm.get('totalVolume')?.errors?.['maxDecimalsVolume']">Massimo 4 decimali consentiti</span>
                <span *ngIf="distributiveForm.get('totalVolume')?.errors?.['invalidNumber']">Inserisci un numero valido</span>
              </div>
            </div>
          </div>
          
          <!-- Info box -->
          <div class="alert alert-info">
            <i class="fas fa-info-circle me-2"></i>
            <strong>Nota:</strong> Questa operazione sostituirà tutti i colli esistenti e creerà automaticamente il numero specificato di colli con peso e volume distribuiti in modo equo. Tutti i colli saranno inizialmente chiusi.
          </div>
        </form>
      </div>
      
      <div class="custom-popup-footer">
        <button type="button" class="btn btn-secondary" (click)="closeDistributiveInsertPopup()">
          <i class="fas fa-times me-1"></i>{{ 'SHIPMENT_REQUEST.DISTRIBUTIVE_CANCEL' | translate }}
        </button>
        <button 
          type="button" 
          class="btn btn-primary" 
          (click)="processDistributiveInsertion()"
          [disabled]="!distributiveForm || distributiveForm.invalid">
          <i class="fas fa-th me-1"></i>{{ 'SHIPMENT_REQUEST.DISTRIBUTIVE_CREATE' | translate }}
        </button>
      </div>
    </div>
  </div>

<div class="stars-container" *ngIf="showConfetti">
  <div class="star" *ngFor="let item of [].constructor(80); let i = index"
       [style.left.%]="(mathUtil.random() * 100)"
       [style.animation-duration.s]="(3 + mathUtil.random() * 4)"
       [ngClass]="'star-type-' + (i % 5)">
  </div>
</div>

<!-- Tour Guide Component -->
<app-tour-guide></app-tour-guide>
